'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var formdataNode = require('formdata-node');
var axios = require('axios');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/* Delete this comment once you know that the current PREFIX is right*/
const BARONG_PREFIX = "/auth";
const BARONG_API_END_POINT_ME = "/resource/users/me";
const BARONG_API_END_POINT_PASSWORD = "/resource/users/password";
const BARONG_API_END_POINT_OTP = "/resource/otp";
const BARONG_API_END_POINT_GET_ACTIVITIES = "/resource/users/activity";
const BARONG_API_END_POINT_GET_API_KEY = "/resource/api_keys";
const BARONG_API_END_POINT_SESSIONS = "/identity/sessions";
const BARONG_API_END_POINT_USERS = "/identity/users";
const BARONG_API_END_POINT_CONFIRM_USER = "/identity/users/email/confirm_code";
const BARONG_API_END_POINT_PASSWORD_GENERATE_CODE = "/identity/users/password/generate_code";
const BARONG_API_END_POINT_PASSWORD_CONFIRM_CODE = "/identity/users/password/confirm_code";
const BARONG_API_END_POINT_EMAIL_GENERATE_CODE = "/identity/users/email/generate_code";
const BARONG_API_END_POINT_PASSWORD_VALIDATE = "/identity/password/validate";
const BARONG_API_END_POINT_CONFIGS = "/public/configs";
const BARONG_API_END_POINT_ADMIN_IDENTITY_SESSIONS_AUTH0_LOG_IN = "/identity/sessions/auth0/login";
const BARONG_API_END_POINT_ADMIN_IDENTITY_SESSIONS_AUTH0_REGISTER = "/identity/sessions/auth0/register";
const BARONG_API_END_POINT_PUBLIC_AUTH0_CONFIG = "/public/configs/auth0";
const BARONG_API_END_POINT_RESOURCE_DATA_STORAGE = "/resource/data_storage";

class BarongMember {
    constructor(authenticationService) {
        this.url = authenticationService.serviceConfig.noPrefix
            ? `${authenticationService.serviceConfig.url}`
            : `${authenticationService.serviceConfig.url}${BARONG_PREFIX}`;
        this.authenticationService = authenticationService;
    }
    async updateApiKeys(form) {
        const { kid } = form, data = __rest(form, ["kid"]);
        return await this.authenticationService.fetch({
            method: "PATCH",
            url: `${this.url}${BARONG_API_END_POINT_GET_API_KEY}/${kid}`,
            data,
        });
    }
    async deleteApiKeys(kid, totp_code) {
        return await this.authenticationService.fetch({
            method: "DELETE",
            url: `${this.url}${BARONG_API_END_POINT_GET_API_KEY}/${kid}`,
            data: {
                totp_code,
            },
        });
    }
    async getApiKeys(ordering, order_by) {
        return await this.authenticationService.fetch({
            method: "GET",
            url: `${this.url}${BARONG_API_END_POINT_GET_API_KEY}`,
            params: {
                ordering,
                order_by,
            },
        });
    }
    async generateApiKeys(algorithm, totp_code) {
        return await this.authenticationService.fetch({
            method: "POST",
            url: `${this.url}${BARONG_API_END_POINT_GET_API_KEY}`,
            data: {
                algorithm,
                totp_code,
            },
        });
    }
    /** Changes the user password */
    async changePassword(form) {
        return await this.authenticationService.fetch({
            method: "PUT",
            url: `${this.url}${BARONG_API_END_POINT_PASSWORD}`,
            data: form,
        });
    }
    /** Get the user activities from a given topic
     * @param page defaults to 1
     * @param limit defaults to 100 (max)
     */
    async getActivities(topic, page = 1, limit = 100) {
        return this.authenticationService.fetch({
            method: "GET",
            url: `${this.url}${BARONG_API_END_POINT_GET_ACTIVITIES}/${encodeURIComponent(topic)}`,
            params: { page: page.toString(), limit: limit.toString() },
        });
    }
    /** Get the current user */
    async getUser() {
        return this.authenticationService.fetch({
            method: "GET",
            url: `${this.url}${BARONG_API_END_POINT_ME}`,
            withCredentials: true,
        });
    }
    async updateUserData(userData) {
        return this.authenticationService.fetch({
            method: "PUT",
            url: `${this.url}${BARONG_API_END_POINT_ME}`,
            data: { data: userData },
        });
    }
    /** Enable or disable the two factor status */
    async changeTwoFactorStatus(code, status) {
        return this.authenticationService.fetch({
            method: "POST",
            url: `${this.url}${BARONG_API_END_POINT_OTP}/${encodeURIComponent(status)}`,
            data: { code },
        });
    }
    /** Generates the two factor status */
    async generateTwoFactorCode() {
        return this.authenticationService.fetch({
            method: "POST",
            url: `${this.url}${BARONG_API_END_POINT_OTP}/generate_qrcode`,
        });
    }
    /** Destroys the current session
     *
     * WARNING: this will leave your member instance unnusable unless you login with barong's public method */
    async logout() {
        return await this.authenticationService.fetch({
            method: "DELETE",
            url: `${this.url}${BARONG_API_END_POINT_SESSIONS}`,
            responseType: "text",
        });
    }
    /** Post data storage of a member */
    async dataStorage(info) {
        return this.authenticationService.fetch({
            method: "POST",
            url: `${this.url}${BARONG_API_END_POINT_RESOURCE_DATA_STORAGE}`,
            data: { title: "last_device", data: JSON.stringify(info) },
        });
    }
}

var ServiceEnvEnum;
(function (ServiceEnvEnum) {
    ServiceEnvEnum["TEST"] = "test";
    ServiceEnvEnum["TEST2"] = "test2";
    ServiceEnvEnum["TEST3"] = "test3";
    ServiceEnvEnum["STAGE"] = "stage";
    ServiceEnvEnum["PROD"] = "prod";
    ServiceEnvEnum["LOCAL"] = "local";
})(ServiceEnvEnum || (ServiceEnvEnum = {}));

const API_URL_CONDITION = {
    [ServiceEnvEnum.LOCAL]: "http://local.letsbit.io:8080/api",
    [ServiceEnvEnum.PROD]: "https://api.letsbit.io/api",
    [ServiceEnvEnum.STAGE]: "https://api-stage.cubetadecapitales.com.ar/api",
    [ServiceEnvEnum.TEST]: "https://api-test.cubetadecapitales.com.ar/api",
    [ServiceEnvEnum.TEST2]: "https://api-test2.cubetadecapitales.com.ar/api",
    [ServiceEnvEnum.TEST3]: "https://api-test3.cubetadecapitales.com.ar/api",
};

// import "isomorphic-fetch";
class PublicMicroService {
    constructor(serviceConfig) {
        this.serviceConfig = serviceConfig;
        this.serviceConfig = serviceConfig;
    }
    async fetch(params) {
        const _a = this.serviceConfig, { prefix = "", env, version, url } = _a, rest = __rest(_a, ["prefix", "env", "version", "url"]);
        const headers = params.headers || {};
        if (params.data instanceof formdataNode.FormData) {
            headers["Content-Type"] = "multipart/form-data";
        }
        else {
            headers["Content-Type"] = "application/json";
        }
        headers["X-app-version"] = this.serviceConfig.appVersion || "noVersion";
        headers["X-app-live-version"] =
            this.serviceConfig.appLiveVersion || "noLiveVersion";
        const response = await axios__default["default"].request(Object.assign(Object.assign(Object.assign({}, rest), params), { headers, data: params.data || {}, url: url
                ? `${url}${prefix}${params.url}`
                : `${API_URL_CONDITION[env]}/${version}${prefix}${params.url}` }));
        return response;
    }
}

class BarongPublic extends PublicMicroService {
    constructor(serviceConfig) {
        super(Object.assign(Object.assign({}, serviceConfig), { prefix: serviceConfig.noPrefix ? "" : BARONG_PREFIX }));
    }
    /** Confirms an account */
    async confirmUser(token) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_CONFIRM_USER,
            data: { token },
            withCredentials: true,
        });
    }
    /** Send password reset instructions */
    async resetPassword(email, captcha_response) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_PASSWORD_GENERATE_CODE,
            data: { email, captcha_response },
        });
    }
    /** Send confirmations instructions */
    async generateEmailConfirmation(email, captcha_response) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_EMAIL_GENERATE_CODE,
            data: { email, captcha_response },
        });
    }
    /** Test the password strength */
    async validatePassword(password) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_PASSWORD_VALIDATE,
            data: { password },
        });
    }
    /** Creates a new user */
    async register(form) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_USERS,
            data: form,
        });
    }
    /** Changes the user password from the given email token */
    async changePassword(form) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_PASSWORD_CONFIRM_CODE,
            data: form,
        });
    }
    async login(form) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_SESSIONS,
            data: form,
            withCredentials: true,
        });
    }
    async getConfigs() {
        return this.fetch({
            method: "GET",
            url: BARONG_API_END_POINT_CONFIGS,
        });
    }
    async getAuth0Configs() {
        return this.fetch({
            method: "GET",
            url: BARONG_API_END_POINT_PUBLIC_AUTH0_CONFIG,
        });
    }
    /** Creates a new user with auth0 */
    async registerAuth0(form) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_ADMIN_IDENTITY_SESSIONS_AUTH0_REGISTER,
            data: form,
        });
    }
    async loginAuth0(form) {
        return this.fetch({
            method: "POST",
            url: BARONG_API_END_POINT_ADMIN_IDENTITY_SESSIONS_AUTH0_LOG_IN,
            data: form,
            withCredentials: true,
        });
    }
}

/* Delete this comment once you know that the current PREFIX is right*/
const HODOR_PREFIX = "/lb/auth";
const HODOR_API_END_POINT_LOGIN_API_BEGIN = "/identity/login/api/begin";
const HODOR_API_END_POINT_LOGIN_BROWSER_BEGIN = "/identity/login/browser/begin";
const HODOR_API_END_POINT_LOGIN_FINISH = "/identity/login/finish";
const HODOR_API_END_POINT_PASSWORD_GENERATE_CODE = "/identity/password/generate_code";
const HODOR_API_END_POINT_PASSWORD_CONFIRM_CODE = "/identity/password/confirm_code";
const HODOR_API_END_POINT_REGISTER_ORGANIZATION = "/organization/register";

class HodorPublic extends PublicMicroService {
    constructor(serviceConfig) {
        super(Object.assign(Object.assign({}, serviceConfig), { prefix: HODOR_PREFIX }));
    }
    async loginBrowserBegin(data) {
        return this.fetch({
            method: "POST",
            url: HODOR_API_END_POINT_LOGIN_BROWSER_BEGIN,
            data: data,
        });
    }
    async loginAPIBegin(data, captcha_response) {
        return this.fetch({
            method: "POST",
            url: HODOR_API_END_POINT_LOGIN_API_BEGIN,
            data: data,
            headers: {
                "x-appcheck-token": captcha_response || "",
            },
        });
    }
    async loginFinish(flow_id, data) {
        return this.fetch({
            method: "POST",
            url: HODOR_API_END_POINT_LOGIN_FINISH,
            params: { flow_id },
            data: data,
            withCredentials: true,
        });
    }
    async registerOrganization(data, captcha_response) {
        return this.fetch({
            method: "POST",
            url: HODOR_API_END_POINT_REGISTER_ORGANIZATION,
            data: data,
            headers: {
                "x-appcheck-token": captcha_response || "",
            },
        });
    }
    async resetPassword(email, captcha_response) {
        return this.fetch({
            method: "POST",
            url: HODOR_API_END_POINT_PASSWORD_GENERATE_CODE,
            data: { email, captcha_response },
            headers: {
                "x-appcheck-token": captcha_response || "",
            },
        });
    }
    async changePassword(form) {
        return this.fetch({
            method: "POST",
            url: HODOR_API_END_POINT_PASSWORD_CONFIRM_CODE,
            data: form,
        });
    }
}

var USER_STATE;
(function (USER_STATE) {
    USER_STATE["ACTIVE"] = "active";
    USER_STATE["BANNED"] = "banned";
    USER_STATE["PENDING"] = "pending";
    USER_STATE["LOCKED"] = "locked";
    USER_STATE["NONE"] = "none";
    USER_STATE["RESTRICTED"] = "restricted";
    USER_STATE["FROZEN"] = "frozen";
    USER_STATE["RETRIEVED"] = "retrieved";
})(USER_STATE || (USER_STATE = {}));
var USER_LEVEL;
(function (USER_LEVEL) {
    USER_LEVEL[USER_LEVEL["LEVEL_1"] = 1] = "LEVEL_1";
    USER_LEVEL[USER_LEVEL["LEVEL_2"] = 2] = "LEVEL_2";
    USER_LEVEL[USER_LEVEL["LEVEL_3"] = 3] = "LEVEL_3";
})(USER_LEVEL || (USER_LEVEL = {}));
var LABELS_SCOPE;
(function (LABELS_SCOPE) {
    LABELS_SCOPE["PUBLIC"] = "public";
    LABELS_SCOPE["PRIVATE"] = "private";
})(LABELS_SCOPE || (LABELS_SCOPE = {}));

var SWAP_STATUS;
(function (SWAP_STATUS) {
    SWAP_STATUS["PENDING"] = "pending";
    SWAP_STATUS["PROCESSING"] = "processing";
    SWAP_STATUS["ACCEPTED"] = "accepted";
    SWAP_STATUS["RELEASE_FOUNDS"] = "release-founds";
    SWAP_STATUS["REJECTED"] = "rejected";
    SWAP_STATUS["SUCCEED"] = "succeed";
})(SWAP_STATUS || (SWAP_STATUS = {}));

var GENDERS;
(function (GENDERS) {
    GENDERS["MALE"] = "male";
    GENDERS["FEMALE"] = "female";
    GENDERS["OTHER"] = "other";
})(GENDERS || (GENDERS = {}));
var MARITAL_STATUSES;
(function (MARITAL_STATUSES) {
    MARITAL_STATUSES["SINGLE"] = "single";
    MARITAL_STATUSES["MARRIED"] = "married";
    MARITAL_STATUSES["DIVORCED"] = "divorced";
    MARITAL_STATUSES["WIDOW"] = "widowed";
})(MARITAL_STATUSES || (MARITAL_STATUSES = {}));
var OCCUPATIONS;
(function (OCCUPATIONS) {
    OCCUPATIONS["UNEMPLOYED"] = "unemployed";
    OCCUPATIONS["STUDENT"] = "student";
    OCCUPATIONS["EMPLOYED"] = "employed";
    OCCUPATIONS["RETIRED"] = "retired";
    OCCUPATIONS["BUSINESSMAN"] = "self_employed";
})(OCCUPATIONS || (OCCUPATIONS = {}));
var MEMBER_VIDEO_STATUS;
(function (MEMBER_VIDEO_STATUS) {
    MEMBER_VIDEO_STATUS["GENERATED"] = "generated";
    MEMBER_VIDEO_STATUS["SUBMITTED"] = "submitted";
    MEMBER_VIDEO_STATUS["ACCEPTED"] = "accepted";
    MEMBER_VIDEO_STATUS["REJECTED"] = "rejected";
    MEMBER_VIDEO_STATUS["PENDING_REVIEW"] = "pending_review";
})(MEMBER_VIDEO_STATUS || (MEMBER_VIDEO_STATUS = {}));
var MEMBER_PHOTO_STATUS;
(function (MEMBER_PHOTO_STATUS) {
    MEMBER_PHOTO_STATUS["SUBMITTED"] = "submitted";
    MEMBER_PHOTO_STATUS["ACCEPTED"] = "accepted";
    MEMBER_PHOTO_STATUS["REJECTED"] = "rejected";
    MEMBER_PHOTO_STATUS["SYNC_FAILED"] = "sync_failed";
})(MEMBER_PHOTO_STATUS || (MEMBER_PHOTO_STATUS = {}));
var MEMBER_PERSON_STATUS;
(function (MEMBER_PERSON_STATUS) {
    MEMBER_PERSON_STATUS["SUBMITTED"] = "submitted";
    MEMBER_PERSON_STATUS["ACCEPTED"] = "accepted";
    MEMBER_PERSON_STATUS["REJECTED"] = "rejected";
})(MEMBER_PERSON_STATUS || (MEMBER_PERSON_STATUS = {}));
var MEMBER_CUSTOMER_STATUS;
(function (MEMBER_CUSTOMER_STATUS) {
    MEMBER_CUSTOMER_STATUS["SUBMITTED"] = "submitted";
    MEMBER_CUSTOMER_STATUS["ACCEPTED"] = "accepted";
    MEMBER_CUSTOMER_STATUS["REJECTED"] = "rejected";
    MEMBER_CUSTOMER_STATUS["SYNC_FAILED"] = "sync_failed";
})(MEMBER_CUSTOMER_STATUS || (MEMBER_CUSTOMER_STATUS = {}));
var VERIFICATION_STEPS;
(function (VERIFICATION_STEPS) {
    VERIFICATION_STEPS["CUSTOMER"] = "request_customer_data";
    VERIFICATION_STEPS["NPD"] = "request_natural_person_data";
    VERIFICATION_STEPS["ID"] = "request_document_upload";
    VERIFICATION_STEPS["VIDEO"] = "request_video_upload";
    VERIFICATION_STEPS["DONE"] = "done";
    VERIFICATION_STEPS["LOADING"] = "loading";
    VERIFICATION_STEPS["PHOTO_ID"] = "request_photo_id";
    VERIFICATION_STEPS["PHOTO_INFO"] = "show_photo_info";
    VERIFICATION_STEPS["MANUAL_INPUT"] = "request_manual_input";
    VERIFICATION_STEPS["POSSIBLE_CUIT"] = "show_possible_CUIT";
    VERIFICATION_STEPS["EDIT_CUIT"] = "edit_CUIT";
    VERIFICATION_STEPS["LEGAL_ADDRESS"] = "request_legal_address";
    VERIFICATION_STEPS["VIDEO_GESTURES"] = "request_video_gestures";
    VERIFICATION_STEPS["VIDEO_SELFIE"] = "request_video_selfie";
    VERIFICATION_STEPS["VERIFIED"] = "verified";
    VERIFICATION_STEPS["DONE_JURIDICAL"] = "done_juridical";
})(VERIFICATION_STEPS || (VERIFICATION_STEPS = {}));
var PERSON_TYPES;
(function (PERSON_TYPES) {
    PERSON_TYPES["NATURAL"] = "natural";
    PERSON_TYPES["JURIDICAL"] = "juridical";
})(PERSON_TYPES || (PERSON_TYPES = {}));
var AIV_GENDERS;
(function (AIV_GENDERS) {
    AIV_GENDERS["FEMALE"] = "F";
    AIV_GENDERS["MALE"] = "M";
    AIV_GENDERS["OTHER"] = "X";
})(AIV_GENDERS || (AIV_GENDERS = {}));
var VERIFICATION_FLOW_VERSION;
(function (VERIFICATION_FLOW_VERSION) {
    VERIFICATION_FLOW_VERSION[VERIFICATION_FLOW_VERSION["ONE"] = 1] = "ONE";
    VERIFICATION_FLOW_VERSION[VERIFICATION_FLOW_VERSION["TWO"] = 2] = "TWO";
})(VERIFICATION_FLOW_VERSION || (VERIFICATION_FLOW_VERSION = {}));
var USER_DOCUMENTATION_TYPE;
(function (USER_DOCUMENTATION_TYPE) {
    USER_DOCUMENTATION_TYPE["PROFIT"] = "profit";
    USER_DOCUMENTATION_TYPE["PAYCHECK"] = "paycheck";
    USER_DOCUMENTATION_TYPE["PERSONAL_PROPERTY_TAX_STATEMENT"] = "personal_property_tax_statement";
    USER_DOCUMENTATION_TYPE["INCOME_TAX_STATEMENT"] = "income_tax_statement";
    USER_DOCUMENTATION_TYPE["CAR_SALE_STATEMENT"] = "car_sale_statement";
    USER_DOCUMENTATION_TYPE["PROPERTY_SALE_STATEMENT"] = "property_sale_statement";
    USER_DOCUMENTATION_TYPE["RETIREMENT_CHECK"] = "retirement_check";
    USER_DOCUMENTATION_TYPE["COMPENSATION_STATEMENT"] = "compensation_statement";
    USER_DOCUMENTATION_TYPE["ACCOUNTING_CERTIFICATION"] = "accounting_certification";
    USER_DOCUMENTATION_TYPE["OTHER"] = "other";
    USER_DOCUMENTATION_TYPE["COMPANY_EXTRACT"] = "company_extract";
    USER_DOCUMENTATION_TYPE["MINUTES_OF_MEETING_OF_PARTNERS"] = "minutes_of_meeting_of_partners";
    USER_DOCUMENTATION_TYPE["SOURCE_OF_FUNDS"] = "source_of_funds";
    USER_DOCUMENTATION_TYPE["SWORN_DECLARATION"] = "sworn_declaration";
    USER_DOCUMENTATION_TYPE["DIRECTOR_PASSPORT"] = "director_passport";
    USER_DOCUMENTATION_TYPE["VERIFICATION_SUMARY"] = "verification_summary";
    USER_DOCUMENTATION_TYPE["ULTIMATE_BENEFICIAL_OWNERS"] = "ultimate_beneficial_owners";
})(USER_DOCUMENTATION_TYPE || (USER_DOCUMENTATION_TYPE = {}));
var EXTRA_DOCUMENT_STATUS;
(function (EXTRA_DOCUMENT_STATUS) {
    EXTRA_DOCUMENT_STATUS["SUBMITTED"] = "submitted";
    EXTRA_DOCUMENT_STATUS["ACCEPTED"] = "accepted";
    EXTRA_DOCUMENT_STATUS["REJECTED"] = "rejected";
})(EXTRA_DOCUMENT_STATUS || (EXTRA_DOCUMENT_STATUS = {}));
var INFORMATION_REQUEST_TYPE;
(function (INFORMATION_REQUEST_TYPE) {
    INFORMATION_REQUEST_TYPE["TEXT"] = "text";
    INFORMATION_REQUEST_TYPE["DOCUMENT"] = "document";
})(INFORMATION_REQUEST_TYPE || (INFORMATION_REQUEST_TYPE = {}));
var INFORMATION_REQUEST_STATUS;
(function (INFORMATION_REQUEST_STATUS) {
    INFORMATION_REQUEST_STATUS["NOTIFY_MEMBER"] = "notify_member";
    INFORMATION_REQUEST_STATUS["AWAITING_MEMBER"] = "awaiting_member";
    INFORMATION_REQUEST_STATUS["NOTIFY_ADMIN"] = "notify_admin";
    INFORMATION_REQUEST_STATUS["AWAITING_ADMIN"] = "awaiting_admin";
    INFORMATION_REQUEST_STATUS["ACCEPTED"] = "accepted";
    INFORMATION_REQUEST_STATUS["REJECTED"] = "rejected";
    INFORMATION_REQUEST_STATUS["ARCHIVED"] = "archived";
})(INFORMATION_REQUEST_STATUS || (INFORMATION_REQUEST_STATUS = {}));
var VERIFICATION_REJECTED_REASONS;
(function (VERIFICATION_REJECTED_REASONS) {
    VERIFICATION_REJECTED_REASONS["ALREADY_TAKEN"] = "national_id_already_taken";
})(VERIFICATION_REJECTED_REASONS || (VERIFICATION_REJECTED_REASONS = {}));
var FLOW_NEXT_STEP;
(function (FLOW_NEXT_STEP) {
    FLOW_NEXT_STEP["CREATE_NEW_FLOW"] = "create_new_flow";
    FLOW_NEXT_STEP["NATIONAL_ID"] = "national_id";
    FLOW_NEXT_STEP["NATIONAL_ID_RESUBMIT"] = "national_id_resubmit";
    FLOW_NEXT_STEP["NATIONAL_ID_QUEUED"] = "national_id_queued";
    FLOW_NEXT_STEP["VERIFICATION_REJECTED"] = "verification_rejected";
    FLOW_NEXT_STEP["AWAITING_NATIONAL_ID_VERIFICATION"] = "awating_national_id_verification";
    FLOW_NEXT_STEP["NATIONAL_ID_CONFIRM"] = "national_id_data_confirm";
    FLOW_NEXT_STEP["DATA_SCORE"] = "data_score";
    FLOW_NEXT_STEP["NATURAL_PERSON_DATA"] = "natural_person_data";
    FLOW_NEXT_STEP["AWAITING_SCORE_CALCULATION"] = "awaiting_score_calculation";
    FLOW_NEXT_STEP["AWAITING_ADMIN_REVIEW"] = "awaiting_admin_review";
    FLOW_NEXT_STEP["AWAITING_SCORE_EVALUATION"] = "awaiting_score_evaluation";
    FLOW_NEXT_STEP["LIVENESS"] = "liveness";
    FLOW_NEXT_STEP["AWAITING_LIVENESS_VERIFICATION"] = "awaiting_liveness_verification";
    FLOW_NEXT_STEP["AWAITING_LIVENESS_COMPARISON"] = "awaiting_liveness_comparasion";
    FLOW_NEXT_STEP["LIVENESS_REJECTED"] = "liveness_rejected";
    FLOW_NEXT_STEP["COMPLETED"] = "completed";
    FLOW_NEXT_STEP["SKIPPED"] = "skipped";
    FLOW_NEXT_STEP["LEGAL_ADDRESS"] = "legal_address";
    FLOW_NEXT_STEP["CONTINUE_NEW_FLOW"] = "continue_new_flow";
    FLOW_NEXT_STEP["SKIP"] = "skip";
    FLOW_NEXT_STEP["CONTINUE"] = "continue";
    FLOW_NEXT_STEP["LIVENESS_STARTED"] = "liveness_started";
    FLOW_NEXT_STEP["LIVENESS_ACCEPTED"] = "liveness_accepted";
    FLOW_NEXT_STEP["LIVENESS_ENDED"] = "liveness_ended";
    FLOW_NEXT_STEP["AWAITING_LIVENESS_COMPLETED"] = "awaiting_liveness_completed";
    FLOW_NEXT_STEP["ONBOARDING_FLOW_NOT_COMPLETED"] = "onboarding_flow_not_completed";
    FLOW_NEXT_STEP["REVERIFICATION_MAX_ATTEMPTS_REACHED"] = "reverification_max_attempts_reached";
    FLOW_NEXT_STEP["LIVENESS_DOCKET_REJECTED"] = "liveness_docket_rejected";
    FLOW_NEXT_STEP["LIVENESS_DOCKET_REVIEW"] = "liveness_docket_review";
    FLOW_NEXT_STEP["INVALID_COUNTRY"] = "invalid_country";
})(FLOW_NEXT_STEP || (FLOW_NEXT_STEP = {}));
var LIVENESS_MESSAGES;
(function (LIVENESS_MESSAGES) {
    LIVENESS_MESSAGES["NUMBER_DOESNT_MATCH"] = "procedure_number_does_not_match";
    LIVENESS_MESSAGES["DOCUMENT_EXTRACTION_FAILED"] = "document_field_extraction_failed";
    LIVENESS_MESSAGES["NOT_FOLLOW_INSTRUCTIONS"] = "liveness_user_did_not_follow_instrucctions";
})(LIVENESS_MESSAGES || (LIVENESS_MESSAGES = {}));
var FLOW_COUNTRY;
(function (FLOW_COUNTRY) {
    FLOW_COUNTRY["PE"] = "PE";
    FLOW_COUNTRY["CO"] = "CO";
    FLOW_COUNTRY["AR"] = "AR";
})(FLOW_COUNTRY || (FLOW_COUNTRY = {}));
var LIMITS_APPLIES_TO;
(function (LIMITS_APPLIES_TO) {
    LIMITS_APPLIES_TO["LIMIT_INCREMENTATION"] = "limit_incrementation";
    LIMITS_APPLIES_TO["LIMIT_INCREMENTATION_ARB"] = "limit_incrementation_arb";
    LIMITS_APPLIES_TO["ONBOARDING"] = "onboarding";
    LIMITS_APPLIES_TO["UPDATE"] = "update";
    LIMITS_APPLIES_TO["ERROR_ONBOARDING"] = "error - onboarding";
    LIMITS_APPLIES_TO["ONBOARDING_CONTROL_CHAIN"] = "onboarding_control-chain";
})(LIMITS_APPLIES_TO || (LIMITS_APPLIES_TO = {}));
var FLOW_CATEGORIES;
(function (FLOW_CATEGORIES) {
    FLOW_CATEGORIES["ONBOARDING"] = "onboarding";
    FLOW_CATEGORIES["DOCKET_UPDATE"] = "docket_update";
    FLOW_CATEGORIES["REVERIFICATION"] = "reverification";
})(FLOW_CATEGORIES || (FLOW_CATEGORIES = {}));
var PRODUCT_NAME_TERMS_AND_CONDITION;
(function (PRODUCT_NAME_TERMS_AND_CONDITION) {
    PRODUCT_NAME_TERMS_AND_CONDITION["PLATFORM"] = "platform";
    PRODUCT_NAME_TERMS_AND_CONDITION["ARS"] = "ars";
    PRODUCT_NAME_TERMS_AND_CONDITION["CARDS"] = "cards";
    PRODUCT_NAME_TERMS_AND_CONDITION["PAYMENT_SERVICES"] = "pds";
    PRODUCT_NAME_TERMS_AND_CONDITION["CVU_PROVIDED"] = "cvu_provided";
    PRODUCT_NAME_TERMS_AND_CONDITION["USDEEUU"] = "usdeeuu";
    PRODUCT_NAME_TERMS_AND_CONDITION["REFERRALS"] = "referrals";
    PRODUCT_NAME_TERMS_AND_CONDITION["REFERRALS_CAMPAING"] = "rewards_campaigns";
    PRODUCT_NAME_TERMS_AND_CONDITION["ARBITRATORS"] = "arbitrators";
    PRODUCT_NAME_TERMS_AND_CONDITION["USDL"] = "usdl";
    PRODUCT_NAME_TERMS_AND_CONDITION["FCI"] = "fci";
    PRODUCT_NAME_TERMS_AND_CONDITION["CRYPTO"] = "crypto";
    PRODUCT_NAME_TERMS_AND_CONDITION["ALPACA"] = "alpaca";
    PRODUCT_NAME_TERMS_AND_CONDITION["ALYC_ARG"] = "alyc-arg";
})(PRODUCT_NAME_TERMS_AND_CONDITION || (PRODUCT_NAME_TERMS_AND_CONDITION = {}));

var LEGAL_NOTICES_CURRENCY_TYPES;
(function (LEGAL_NOTICES_CURRENCY_TYPES) {
    LEGAL_NOTICES_CURRENCY_TYPES["BUYTERMS"] = "buy-terms";
    LEGAL_NOTICES_CURRENCY_TYPES["TERMS"] = "terms";
})(LEGAL_NOTICES_CURRENCY_TYPES || (LEGAL_NOTICES_CURRENCY_TYPES = {}));
var LEGAL_NOTICES_COUNTRY_TYPES;
(function (LEGAL_NOTICES_COUNTRY_TYPES) {
    LEGAL_NOTICES_COUNTRY_TYPES["PRIVACY_POLICY"] = "privacy_policy";
    LEGAL_NOTICES_COUNTRY_TYPES["TERMS"] = "terms";
    LEGAL_NOTICES_COUNTRY_TYPES["PEP"] = "pep";
})(LEGAL_NOTICES_COUNTRY_TYPES || (LEGAL_NOTICES_COUNTRY_TYPES = {}));

var ENTITY_TYPE;
(function (ENTITY_TYPE) {
    ENTITY_TYPE["FIAT"] = "fiat";
    ENTITY_TYPE["CRYPTO"] = "crypto";
    ENTITY_TYPE["EXCHANGE"] = "exchange";
    ENTITY_TYPE["WALLET"] = "wallet";
})(ENTITY_TYPE || (ENTITY_TYPE = {}));
var CURRENCY_TYPE;
(function (CURRENCY_TYPE) {
    CURRENCY_TYPE["FIAT"] = "fiat";
    CURRENCY_TYPE["COIN"] = "coin";
    CURRENCY_TYPE["ALL"] = "all";
})(CURRENCY_TYPE || (CURRENCY_TYPE = {}));
var ENTITY_STATE;
(function (ENTITY_STATE) {
    ENTITY_STATE["ACTIVE"] = "active";
    ENTITY_STATE["ARCHIVED"] = "archived";
})(ENTITY_STATE || (ENTITY_STATE = {}));
var CONTACT_STATE;
(function (CONTACT_STATE) {
    CONTACT_STATE["ACTIVE"] = "active";
    CONTACT_STATE["ARCHIVED"] = "archived";
})(CONTACT_STATE || (CONTACT_STATE = {}));
var CONTACT_TYPE;
(function (CONTACT_TYPE) {
    CONTACT_TYPE["ENTITY"] = "entity";
    CONTACT_TYPE["PERSON"] = "person";
})(CONTACT_TYPE || (CONTACT_TYPE = {}));
var CONTACT_ADDRESS_STATE;
(function (CONTACT_ADDRESS_STATE) {
    CONTACT_ADDRESS_STATE["PENDING"] = "pending";
    CONTACT_ADDRESS_STATE["ACTIVE"] = "active";
    CONTACT_ADDRESS_STATE["PROCESSING"] = "processing";
    CONTACT_ADDRESS_STATE["UNDER_REVIEW"] = "under_review";
    CONTACT_ADDRESS_STATE["ARCHIVED"] = "archived";
    CONTACT_ADDRESS_STATE["AML_BLOCKED"] = "aml_blocked";
    CONTACT_ADDRESS_STATE["REJECTED"] = "rejected";
})(CONTACT_ADDRESS_STATE || (CONTACT_ADDRESS_STATE = {}));
var ACCOUNT_TYPE;
(function (ACCOUNT_TYPE) {
    ACCOUNT_TYPE["SAVING"] = "ahorro";
    ACCOUNT_TYPE["BOOKING"] = "corriente";
    ACCOUNT_TYPE["USD_SAVING"] = "savings";
    ACCOUNT_TYPE["USD_BOOKING"] = "checking";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
var PERSON_TYPE;
(function (PERSON_TYPE) {
    PERSON_TYPE["INDIVIDUAL"] = "F";
    PERSON_TYPE["BUSINESS"] = "J";
})(PERSON_TYPE || (PERSON_TYPE = {}));

var FEE_TYPES;
(function (FEE_TYPES) {
    FEE_TYPES["VALUE"] = "value";
    FEE_TYPES["PERCENTAGE"] = "percentage";
    FEE_TYPES["BOTH"] = "both";
})(FEE_TYPES || (FEE_TYPES = {}));
var HISTORY_OPERATION_TYPE;
(function (HISTORY_OPERATION_TYPE) {
    HISTORY_OPERATION_TYPE["TRADE"] = "trade";
    HISTORY_OPERATION_TYPE["DEPOSIT"] = "deposit";
    HISTORY_OPERATION_TYPE["WITHDRAW"] = "withdraw";
    HISTORY_OPERATION_TYPE["MERK_ACCOUNT_MOVEMENT"] = "merk_account_movement";
    HISTORY_OPERATION_TYPE["REFERRER_PAYOUT"] = "referrer_payout";
    HISTORY_OPERATION_TYPE["INTEREST_PAYMENT"] = "interest_payment";
    HISTORY_OPERATION_TYPE["CARD_TRANSACTIONS"] = "card_transactions";
    HISTORY_OPERATION_TYPE["ADJUSTMENT"] = "adjustment";
    HISTORY_OPERATION_TYPE["REWARD"] = "reward";
    HISTORY_OPERATION_TYPE["AUTOSWAP"] = "autoswap";
    HISTORY_OPERATION_TYPE["PAYMENT"] = "payment";
    HISTORY_OPERATION_TYPE["WITHHOLDING"] = "withholding";
    HISTORY_OPERATION_TYPE["WITHHOLDINGS_WITHHOLDING"] = "withholdings_withholding";
    HISTORY_OPERATION_TYPE["DOLLARIZE"] = "dollarize";
    HISTORY_OPERATION_TYPE["MERK_ORDER"] = "merk_order";
})(HISTORY_OPERATION_TYPE || (HISTORY_OPERATION_TYPE = {}));
var BANNER_TYPE;
(function (BANNER_TYPE) {
    BANNER_TYPE["HOME"] = "home";
    BANNER_TYPE["USDEEUU"] = "usdeeuu";
})(BANNER_TYPE || (BANNER_TYPE = {}));
var CURRENCY_FILTER_PARAMS;
(function (CURRENCY_FILTER_PARAMS) {
    CURRENCY_FILTER_PARAMS["PREFERRED_CURRENCY"] = "preferred_currency";
    CURRENCY_FILTER_PARAMS["PAYMENT_CARD_CURRENCY"] = "payment_card_currency";
})(CURRENCY_FILTER_PARAMS || (CURRENCY_FILTER_PARAMS = {}));
var VERIFICATION_ENTERPRISE_STEPS;
(function (VERIFICATION_ENTERPRISE_STEPS) {
    VERIFICATION_ENTERPRISE_STEPS["CUSTOMER_DATA"] = "customer-data";
    VERIFICATION_ENTERPRISE_STEPS["JURIDICAL_DATA"] = "juridical-data";
    VERIFICATION_ENTERPRISE_STEPS["EXTRA_DOCS"] = "extra-docs";
    VERIFICATION_ENTERPRISE_STEPS["ENDED"] = "ended";
})(VERIFICATION_ENTERPRISE_STEPS || (VERIFICATION_ENTERPRISE_STEPS = {}));
var ONBOARDING_FLOW;
(function (ONBOARDING_FLOW) {
    ONBOARDING_FLOW["LOCAL"] = "local";
    ONBOARDING_FLOW["FOREIGN"] = "FOREIGN";
})(ONBOARDING_FLOW || (ONBOARDING_FLOW = {}));
var ROUTE_TYPE;
(function (ROUTE_TYPE) {
    ROUTE_TYPE["PROMOTION_CODES_ASIGN"] = "promotion_code_asign";
    ROUTE_TYPE["DOCKET_UPDATE_VERIFY_IDENTITY"] = "docket_update_verify_identity";
    ROUTE_TYPE["DOCKET_UPDATE_LEGAL_ADDRESS"] = "docket_update_legal_address";
    ROUTE_TYPE["DOCKET_UPDATE_START_METAMAP"] = "docket_update_start_metamap";
    ROUTE_TYPE["DOCKET_UPDATE_ON_VERIFICATION"] = "docket_update_on_verification";
    ROUTE_TYPE["DOCKET_UPDATE_REJECTED"] = "docket_update_rejected";
    ROUTE_TYPE["DOCKET_UPDATE_ADMIN_REVIEW"] = "docket_update_admin_review";
    ROUTE_TYPE["DOCKET_UPDATE_LIVENESS_REDO_ERRORS"] = "docket_update_liveness_redo_errors";
    ROUTE_TYPE["USER_VERIFICATION_CHOOSE_COUNTRY"] = "user_verification_choose_country";
    ROUTE_TYPE["USER_VERIFICATION_INVALID_COUNTRY"] = "user_verification_invalid_country";
    ROUTE_TYPE["USER_VERIFICATION_COUNTRY_TYPE_ID"] = "user_verification_country_type_id";
    ROUTE_TYPE["USER_VERIFICATION_NATIONAL_ID_INVALID"] = "user_verification_national_id_invalid";
    ROUTE_TYPE["USER_VERIFICATION_NATIONAL_ID_CONFIRM"] = "user_verification_national_id_confirm";
    ROUTE_TYPE["USER_VERIFICATION_NATIONAL_ID_RESUBMIT"] = "user_verification_national_id_resubmit";
    ROUTE_TYPE["USER_VERIFICATION_NATIONAL_ID_QUEUED"] = "user_verification_national_id_queued";
    ROUTE_TYPE["USER_VERIFICATION_ERROR_REJECTED"] = "user_verification_error_rejected";
    ROUTE_TYPE["USER_VERIFICATION_MY_CUIT"] = "user_verification_my_cuit";
    ROUTE_TYPE["USER_VERIFICATION_LEGAL_ADDRESS"] = "user_verification_legal_address";
    ROUTE_TYPE["USER_VERIFICATION_NAME_INPUT"] = "user_verification_name_input";
    ROUTE_TYPE["USER_VERIFICATION_PE_COL_GENDER"] = "user_verification_pe_col_gender";
    ROUTE_TYPE["USER_VERIFICATION_START_METAMAP"] = "user_verification_start_metamap";
    ROUTE_TYPE["USER_VERIFICATION_AWAITING_NATIONAL_ID"] = "user_verification_awaiting_national_id";
    ROUTE_TYPE["USER_VERIFICATION_AWAITING_ADMIN_REVIEW"] = "user_verification_awaiting_admin_review";
    ROUTE_TYPE["USER_VERIFICATION_AWAITING_SCORE"] = "user_verification_awaiting_score";
    ROUTE_TYPE["USER_VERIFICATION_AWAITING_LIVENESS"] = "user_verification_awaiting_liveness";
    ROUTE_TYPE["USER_VERIFICATION_AWAITING_LIVENESS_COMPLETED"] = "user_verification_awaiting_liveness_completed";
    ROUTE_TYPE["USER_VERIFICATION_AWAITING"] = "user_verification_awaiting";
    ROUTE_TYPE["USER_VERIFICATION_ERROR"] = "user_verification_error";
    ROUTE_TYPE["USER_VERIFICATION_LIVENESS_REDO_ERRORS"] = "user_verification_liveness_redo_errors";
    ROUTE_TYPE["USER_VERIFICATION_JURIDICAL_PERSONS_WEB"] = "user_verification_juridical_persons_web";
    ROUTE_TYPE["TERMS_AND_CONDITIONS"] = "terms_and_conditions";
    ROUTE_TYPE["ONBOARDING_WELCOME"] = "onboarding_welcome";
    ROUTE_TYPE["CONVERSION_HOME"] = "conversion_home";
    ROUTE_TYPE["RETRIEVE_INFO"] = "retrieve_info";
    ROUTE_TYPE["FREEZE_INFO"] = "freeze_info";
    ROUTE_TYPE["HOME"] = "home";
    ROUTE_TYPE["ERROR_PAGE"] = "error";
    ROUTE_TYPE["NOT_ACTIVE_INFO"] = "not_active_info";
    ROUTE_TYPE["REVERIFICATION_ENROLL"] = "reverification_enroll";
    ROUTE_TYPE["REVERIFICATION_VERIFY_IDENTITY"] = "reverification_verify_identity";
    ROUTE_TYPE["REVERIFICATION_ON_ERROR"] = "reverification_on_error";
    ROUTE_TYPE["REVERIFICATION_ON_VALIDATION"] = "reverification_on_validation";
    ROUTE_TYPE["REVERIFICATION_MAX_ATTEMPTS_REACHED"] = "reverification_max_attempts_reached";
    ROUTE_TYPE["REVERIFICATION_ON_START_ERROR"] = "reverification_on_start_error";
    ROUTE_TYPE["REVERIFICATION_START_METAMAP"] = "reverification_start_metamap";
})(ROUTE_TYPE || (ROUTE_TYPE = {}));
var ACCOUNT_ADVISOR_TYPE;
(function (ACCOUNT_ADVISOR_TYPE) {
    ACCOUNT_ADVISOR_TYPE["PERSONAL_ADVISOR"] = "personal_advisor";
    ACCOUNT_ADVISOR_TYPE["INTERCOM"] = "intercom";
})(ACCOUNT_ADVISOR_TYPE || (ACCOUNT_ADVISOR_TYPE = {}));
var CATEGORIES_AUTOMATED_ITEM;
(function (CATEGORIES_AUTOMATED_ITEM) {
    CATEGORIES_AUTOMATED_ITEM["LAST_ADDED_SECURITIES"] = "last_added_securities";
    CATEGORIES_AUTOMATED_ITEM["TOP_SECURITIES"] = "top_securities";
    CATEGORIES_AUTOMATED_ITEM["BOTTOM_SECURITIES"] = "bottom_securities";
    CATEGORIES_AUTOMATED_ITEM["TOP_CRIPTO"] = "top_crypto";
})(CATEGORIES_AUTOMATED_ITEM || (CATEGORIES_AUTOMATED_ITEM = {}));

var TRADE_SIDES;
(function (TRADE_SIDES) {
    TRADE_SIDES["BUY"] = "buy";
    TRADE_SIDES["SELL"] = "sell";
})(TRADE_SIDES || (TRADE_SIDES = {}));

var DEPOSIT_STATE_OPTIONS;
(function (DEPOSIT_STATE_OPTIONS) {
    DEPOSIT_STATE_OPTIONS["SUBMITTED"] = "submitted";
    DEPOSIT_STATE_OPTIONS["CANCELED"] = "canceled";
    DEPOSIT_STATE_OPTIONS["BLOCKED"] = "blocked";
    DEPOSIT_STATE_OPTIONS["REJECTED"] = "rejected";
    DEPOSIT_STATE_OPTIONS["ACCEPTED"] = "accepted";
    DEPOSIT_STATE_OPTIONS["SKIPPED"] = "skipped";
    DEPOSIT_STATE_OPTIONS["COLLECTED"] = "collected";
})(DEPOSIT_STATE_OPTIONS || (DEPOSIT_STATE_OPTIONS = {}));
var TIME_PERIOD_VALUES;
(function (TIME_PERIOD_VALUES) {
    TIME_PERIOD_VALUES["DAILY"] = "daily";
    TIME_PERIOD_VALUES["MONTHLY"] = "monthly";
    TIME_PERIOD_VALUES["YEARLY"] = "yearly";
})(TIME_PERIOD_VALUES || (TIME_PERIOD_VALUES = {}));
var KIND_VALUES;
(function (KIND_VALUES) {
    KIND_VALUES["VOLUME"] = "volume";
    KIND_VALUES["QUANTITY"] = "quantity";
})(KIND_VALUES || (KIND_VALUES = {}));
var OPERATIONS_VALUES;
(function (OPERATIONS_VALUES) {
    OPERATIONS_VALUES["WITHDRAW"] = "withdraw";
    OPERATIONS_VALUES["DEPOSIT"] = "deposit";
})(OPERATIONS_VALUES || (OPERATIONS_VALUES = {}));
var WithdrawOperationState;
(function (WithdrawOperationState) {
    WithdrawOperationState["PREPARED"] = "prepared";
    WithdrawOperationState["SUBMITTED"] = "submitted";
    WithdrawOperationState["CANCELED"] = "canceled";
    WithdrawOperationState["ACCEPTED"] = "accepted";
    WithdrawOperationState["REJECTED"] = "rejected";
    WithdrawOperationState["PROCESSING"] = "processing";
    WithdrawOperationState["SKIPPED"] = "skipped";
    WithdrawOperationState["SUCCEED"] = "succeed";
    WithdrawOperationState["FAILED"] = "failed";
    WithdrawOperationState["WAITING_AUTHORIZATION"] = "waiting_authorization";
    WithdrawOperationState["EXPIRED"] = "expired";
    WithdrawOperationState["UNAUTHORIZED"] = "unauthorized";
})(WithdrawOperationState || (WithdrawOperationState = {}));
var FEE_TYPE;
(function (FEE_TYPE) {
    FEE_TYPE["VALUE"] = "value";
    FEE_TYPE["PERCENTAGE"] = "percentage";
    FEE_TYPE["BOTH"] = "both";
})(FEE_TYPE || (FEE_TYPE = {}));
var WithdrawRequestDetailsState;
(function (WithdrawRequestDetailsState) {
    WithdrawRequestDetailsState["SUBMITTED"] = "submitted";
    WithdrawRequestDetailsState["VERIFYING"] = "verifying";
    WithdrawRequestDetailsState["PENDING"] = "pending";
    WithdrawRequestDetailsState["ERROR"] = "error";
    WithdrawRequestDetailsState["FAILED"] = "failed";
    WithdrawRequestDetailsState["ARCHIVED"] = "archived";
    WithdrawRequestDetailsState["PROCESSING"] = "processing";
    WithdrawRequestDetailsState["SUCCEED"] = "succeed";
})(WithdrawRequestDetailsState || (WithdrawRequestDetailsState = {}));
var WithdrawRequestState;
(function (WithdrawRequestState) {
    WithdrawRequestState["SUBMITTED"] = "submitted";
    WithdrawRequestState["CREATING"] = "creating";
    WithdrawRequestState["VERIFYING"] = "verifying";
    WithdrawRequestState["PENDING"] = "pending";
    WithdrawRequestState["PROCESSING"] = "processing";
    WithdrawRequestState["SUCCEED"] = "succeed";
    WithdrawRequestState["FAILED"] = "failed";
    WithdrawRequestState["REVIEW"] = "review";
})(WithdrawRequestState || (WithdrawRequestState = {}));
var EXTERNAL_PAYMENT_ADDRESS_STATES;
(function (EXTERNAL_PAYMENT_ADDRESS_STATES) {
    EXTERNAL_PAYMENT_ADDRESS_STATES["PENDING"] = "pending";
    EXTERNAL_PAYMENT_ADDRESS_STATES["REJECTED"] = "rejected";
    EXTERNAL_PAYMENT_ADDRESS_STATES["ACTIVE"] = "active";
    EXTERNAL_PAYMENT_ADDRESS_STATES["PROCESSING"] = "processing";
    EXTERNAL_PAYMENT_ADDRESS_STATES["UNDER_REVIEW"] = "under_review";
    EXTERNAL_PAYMENT_ADDRESS_STATES["ARCHIVED"] = "archived";
    EXTERNAL_PAYMENT_ADDRESS_STATES["AML_BLOCKED"] = "aml_blocked";
})(EXTERNAL_PAYMENT_ADDRESS_STATES || (EXTERNAL_PAYMENT_ADDRESS_STATES = {}));
var EXTERNAL_PAYMENT_ADDRESS_ACCOUNT_TYPES;
(function (EXTERNAL_PAYMENT_ADDRESS_ACCOUNT_TYPES) {
    EXTERNAL_PAYMENT_ADDRESS_ACCOUNT_TYPES["AHORRO"] = "ahorro";
    EXTERNAL_PAYMENT_ADDRESS_ACCOUNT_TYPES["CORRIENTE"] = "corriente";
})(EXTERNAL_PAYMENT_ADDRESS_ACCOUNT_TYPES || (EXTERNAL_PAYMENT_ADDRESS_ACCOUNT_TYPES = {}));
var DEPOSIT_ADDRESS_STATE;
(function (DEPOSIT_ADDRESS_STATE) {
    DEPOSIT_ADDRESS_STATE["PENDING"] = "pending";
    DEPOSIT_ADDRESS_STATE["CREATED"] = "created";
    DEPOSIT_ADDRESS_STATE["AWAITING_TOS"] = "awaiting_tos";
})(DEPOSIT_ADDRESS_STATE || (DEPOSIT_ADDRESS_STATE = {}));
var REMAINING_LIMITS_CATEGORY;
(function (REMAINING_LIMITS_CATEGORY) {
    REMAINING_LIMITS_CATEGORY["OPERATIONAL"] = "operational";
    REMAINING_LIMITS_CATEGORY["OWN_ACCOUNT"] = "own_account";
    REMAINING_LIMITS_CATEGORY["THIRD_PARTY_ACCOUNT"] = "third_party_account";
    REMAINING_LIMITS_CATEGORY["COIN_CONVERTED"] = "coin_converted";
})(REMAINING_LIMITS_CATEGORY || (REMAINING_LIMITS_CATEGORY = {}));
var DEPOSIT_ADDRESS_TYPE;
(function (DEPOSIT_ADDRESS_TYPE) {
    DEPOSIT_ADDRESS_TYPE["PERSONAL_ACCOUNT_ARS"] = "PERSONAL_ACCOUNT_ARS";
    DEPOSIT_ADDRESS_TYPE["PERSONAL_ACCOUNT_CRYPTO"] = "PERSONAL_ACCOUNT_CRYPTO";
    DEPOSIT_ADDRESS_TYPE["PERSONAL_ACCOUNT_BRIDGE"] = "PERSONAL_ACCOUNT_BRIDGE";
    DEPOSIT_ADDRESS_TYPE["OMNIBUS_ACCOUNT"] = "OMNIBUS_ACCOUNT";
    DEPOSIT_ADDRESS_TYPE["PERSONAL_ACCOUNT"] = "PERSONAL_ACCOUNT";
})(DEPOSIT_ADDRESS_TYPE || (DEPOSIT_ADDRESS_TYPE = {}));
var DEPOSIT_ADDRESS_BRIDGE_ACCOUNT_TYPE;
(function (DEPOSIT_ADDRESS_BRIDGE_ACCOUNT_TYPE) {
    DEPOSIT_ADDRESS_BRIDGE_ACCOUNT_TYPE["CHECKING"] = "checking";
    DEPOSIT_ADDRESS_BRIDGE_ACCOUNT_TYPE["SAVINGS"] = "savings";
})(DEPOSIT_ADDRESS_BRIDGE_ACCOUNT_TYPE || (DEPOSIT_ADDRESS_BRIDGE_ACCOUNT_TYPE = {}));
var TransferRequestType;
(function (TransferRequestType) {
    TransferRequestType["DEPOSIT"] = "deposit";
    TransferRequestType["WITHDRAW"] = "withdraw";
})(TransferRequestType || (TransferRequestType = {}));
var TransferRequestStatus;
(function (TransferRequestStatus) {
    TransferRequestStatus["PENDING"] = "pending";
    TransferRequestStatus["PENDING_DOCUMENTATION"] = "pending_documentation";
    TransferRequestStatus["ACCEPTED"] = "accepted";
    TransferRequestStatus["REJECTED"] = "rejected";
})(TransferRequestStatus || (TransferRequestStatus = {}));
var TransferDocumentStatus;
(function (TransferDocumentStatus) {
    TransferDocumentStatus["ACCEPTED"] = "accepted";
    TransferDocumentStatus["REJECTED"] = "rejected";
})(TransferDocumentStatus || (TransferDocumentStatus = {}));
var TransferRequestBankMovementStatus;
(function (TransferRequestBankMovementStatus) {
    TransferRequestBankMovementStatus["MATCHED"] = "matched";
    TransferRequestBankMovementStatus["UNMATCHED"] = "unmatched";
})(TransferRequestBankMovementStatus || (TransferRequestBankMovementStatus = {}));

var COMERCIAL_RULE_TYPE;
(function (COMERCIAL_RULE_TYPE) {
    COMERCIAL_RULE_TYPE["DEPOSIT"] = "DEPOSIT";
    COMERCIAL_RULE_TYPE["QUANTITY"] = "QUANTITY";
})(COMERCIAL_RULE_TYPE || (COMERCIAL_RULE_TYPE = {}));
var CARD_STATUS;
(function (CARD_STATUS) {
    CARD_STATUS["PENDING"] = "pending";
    CARD_STATUS["CREATED"] = "created";
    CARD_STATUS["ACTIVE"] = "active";
    CARD_STATUS["EMBOSSED"] = "embossed";
    CARD_STATUS["BLOCKED"] = "blocked";
    CARD_STATUS["DISABLED"] = "disabled";
    CARD_STATUS["TRACKED"] = "tracked";
    CARD_STATUS["DELIVERY"] = "delivery";
    CARD_STATUS["DELIVERY_FAILED"] = "delivery_failed";
    CARD_STATUS["EXPIRED"] = "expired";
})(CARD_STATUS || (CARD_STATUS = {}));
var CARD_TYPE;
(function (CARD_TYPE) {
    CARD_TYPE["PHYSICAL"] = "physical";
    CARD_TYPE["VIRTUAL"] = "virtual";
    CARD_TYPE["EPHEMERAL"] = "ephemeral";
})(CARD_TYPE || (CARD_TYPE = {}));
var CARD_TYPE_ID;
(function (CARD_TYPE_ID) {
    CARD_TYPE_ID["PHYSICAL"] = "physical_cards";
    CARD_TYPE_ID["VIRTUAL"] = "virtual_cards";
    CARD_TYPE_ID["EPHEMERAL"] = "ephemeral_cards";
    CARD_TYPE_ID["PHYSICAL_PRISMA"] = "prisma_physical_cards";
    CARD_TYPE_ID["VIRTUAL_PRISMA"] = "prisma_virtual_cards";
    CARD_TYPE_ID["EPHEMERAL_PRISMA"] = "prisma_ephemeral_cards";
})(CARD_TYPE_ID || (CARD_TYPE_ID = {}));
var CARD_TYPE_STATUS;
(function (CARD_TYPE_STATUS) {
    CARD_TYPE_STATUS["ACTIVE"] = "active";
    CARD_TYPE_STATUS["ARCHIVED"] = "archived";
})(CARD_TYPE_STATUS || (CARD_TYPE_STATUS = {}));
var CARD_REASON;
(function (CARD_REASON) {
    CARD_REASON["CLIENT_INTERNAL_REASON"] = "CLIENT_INTERNAL_REASON";
    CARD_REASON["USER_INTERNAL_REASON"] = "USER_INTERNAL_REASON";
    CARD_REASON["FRAUDULENT"] = "FRAUDULENT";
    CARD_REASON["LOST"] = "LOST";
    CARD_REASON["STOLEN"] = "STOLEN";
    CARD_REASON["BROKEN"] = "BROKEN";
    CARD_REASON["UPGRADE"] = "UPGRADE";
})(CARD_REASON || (CARD_REASON = {}));
var CARD_TRANSACTION_TYPE;
(function (CARD_TRANSACTION_TYPE) {
    CARD_TRANSACTION_TYPE["PURCHASE"] = "PURCHASE";
    CARD_TRANSACTION_TYPE["WITHDRAWAL"] = "WITHDRAWAL";
    CARD_TRANSACTION_TYPE["EXTRACASH"] = "EXTRACASH";
    CARD_TRANSACTION_TYPE["REFUND"] = "REFUND";
    CARD_TRANSACTION_TYPE["PAYMENT"] = "PAYMENT";
    CARD_TRANSACTION_TYPE["REVERSAL_PURCHASE"] = "REVERSAL_PURCHASE";
    CARD_TRANSACTION_TYPE["REVERSAL_WITHDRAWAL"] = "REVERSAL_WITHDRAWAL";
    CARD_TRANSACTION_TYPE["REVERSAL_EXTRACASH"] = "REVERSAL_EXTRACASH";
    CARD_TRANSACTION_TYPE["REVERSAL_REFUND"] = "REVERSAL_REFUND";
    CARD_TRANSACTION_TYPE["REVERSAL_PAYMENT"] = "REVERSAL_PAYMENT";
    CARD_TRANSACTION_TYPE["REVERSAL"] = "REVERSAL";
    CARD_TRANSACTION_TYPE["VOID"] = "VOID";
})(CARD_TRANSACTION_TYPE || (CARD_TRANSACTION_TYPE = {}));
var CARD_TRANSACTION_STATUS;
(function (CARD_TRANSACTION_STATUS) {
    CARD_TRANSACTION_STATUS["APPROVED"] = "approved";
    CARD_TRANSACTION_STATUS["REJECTED"] = "rejected";
    CARD_TRANSACTION_STATUS["HELD"] = "held";
})(CARD_TRANSACTION_STATUS || (CARD_TRANSACTION_STATUS = {}));
var CARD_TRANSACTION_DETAIL_TYPE;
(function (CARD_TRANSACTION_DETAIL_TYPE) {
    CARD_TRANSACTION_DETAIL_TYPE["BASE"] = "BASE";
    CARD_TRANSACTION_DETAIL_TYPE["FEE"] = "FEE";
    CARD_TRANSACTION_DETAIL_TYPE["TAX"] = "TAX";
    CARD_TRANSACTION_DETAIL_TYPE["EXTRACASH"] = "EXTRACASH";
    CARD_TRANSACTION_DETAIL_TYPE["DISCOUNT"] = "DISCOUNT";
})(CARD_TRANSACTION_DETAIL_TYPE || (CARD_TRANSACTION_DETAIL_TYPE = {}));
var CARD_LIMIT_STATUS;
(function (CARD_LIMIT_STATUS) {
    CARD_LIMIT_STATUS["ACTIVE"] = "active";
    CARD_LIMIT_STATUS["ARCHIVED"] = "archived";
})(CARD_LIMIT_STATUS || (CARD_LIMIT_STATUS = {}));
var CARD_LIMIT_TYPE;
(function (CARD_LIMIT_TYPE) {
    CARD_LIMIT_TYPE["TOTAL"] = "total";
    CARD_LIMIT_TYPE["MONTHLY"] = "monthly";
})(CARD_LIMIT_TYPE || (CARD_LIMIT_TYPE = {}));
var CARD_SHIPMENT_STATUS;
(function (CARD_SHIPMENT_STATUS) {
    CARD_SHIPMENT_STATUS["CREATED"] = "CREATED";
    CARD_SHIPMENT_STATUS["REJECTED"] = "REJECTED";
    CARD_SHIPMENT_STATUS["PENDING"] = "PENDING";
    CARD_SHIPMENT_STATUS["TRACKED"] = "TRACKED";
    CARD_SHIPMENT_STATUS["IN_TRANSIT"] = "IN_TRANSIT";
    CARD_SHIPMENT_STATUS["START_OF_CUSTODY"] = "START_OF_CUSTODY";
    CARD_SHIPMENT_STATUS["END_OF_CUSTODY"] = "END_OF_CUSTODY";
    CARD_SHIPMENT_STATUS["DISTRIBUTION"] = "DISTRIBUTION";
    CARD_SHIPMENT_STATUS["NOT_DELIVERED"] = "NOT_DELIVERED";
    CARD_SHIPMENT_STATUS["DELIVERED"] = "DELIVERED";
    CARD_SHIPMENT_STATUS["DESTRUCTION"] = "DESTRUCTION";
    CARD_SHIPMENT_STATUS["ACCIDENT"] = "ACCIDENT";
})(CARD_SHIPMENT_STATUS || (CARD_SHIPMENT_STATUS = {}));
var CARD_SHIPMENT_STATUS_DETAIL;
(function (CARD_SHIPMENT_STATUS_DETAIL) {
    CARD_SHIPMENT_STATUS_DETAIL["CREATED"] = "CREATED";
    CARD_SHIPMENT_STATUS_DETAIL["REJECTED"] = "REJECTED";
    CARD_SHIPMENT_STATUS_DETAIL["PENDING"] = "PENDING";
    CARD_SHIPMENT_STATUS_DETAIL["TRACKED"] = "TRACKED";
    CARD_SHIPMENT_STATUS_DETAIL["SHIPMENT_CONSOLIDATED"] = "SHIPMENT_CONSOLIDATED";
    CARD_SHIPMENT_STATUS_DETAIL["RECEIVED_BY_WAREHOUSE"] = "RECEIVED_BY_WAREHOUSE";
    CARD_SHIPMENT_STATUS_DETAIL["RECEIVED_BY_CARRIER"] = "RECEIVED_BY_CARRIER";
    CARD_SHIPMENT_STATUS_DETAIL["LEFT_WAREHOUSE"] = "LEFT_WAREHOUSE";
    CARD_SHIPMENT_STATUS_DETAIL["IN_TRANSIT"] = "IN_TRANSIT";
    CARD_SHIPMENT_STATUS_DETAIL["FAILED_DELIVERY_ATTEMPT"] = "FAILED_DELIVERY_ATTEMPT";
    CARD_SHIPMENT_STATUS_DETAIL["INCOMPLETE_ADDRESS"] = "INCOMPLETE_ADDRESS";
    CARD_SHIPMENT_STATUS_DETAIL["WRONG_ADDRESS"] = "WRONG_ADDRESS";
    CARD_SHIPMENT_STATUS_DETAIL["MISSING_SIGNATURE"] = "MISSING_SIGNATURE";
    CARD_SHIPMENT_STATUS_DETAIL["MISSING_DOCUMENTS"] = "MISSING_DOCUMENTS";
    CARD_SHIPMENT_STATUS_DETAIL["CARRIER_CANCELLED_ACCIDENT"] = "CARRIER_CANCELLED_ACCIDENT";
    CARD_SHIPMENT_STATUS_DETAIL["CARRIER_CANCELLED_HOLIDAY"] = "CARRIER_CANCELLED_HOLIDAY";
    CARD_SHIPMENT_STATUS_DETAIL["CARRIER_CANCELLED"] = "CARRIER_CANCELLED";
    CARD_SHIPMENT_STATUS_DETAIL["CARRIER_CANCELLED_VOLUME"] = "CARRIER_CANCELLED_VOLUME";
    CARD_SHIPMENT_STATUS_DETAIL["CARRIER_CANCELLED_VEHICLE"] = "CARRIER_CANCELLED_VEHICLE";
    CARD_SHIPMENT_STATUS_DETAIL["CARRIER_CANCELLED_ZONE"] = "CARRIER_CANCELLED_ZONE";
    CARD_SHIPMENT_STATUS_DETAIL["ACCIDENT_RECOVERY"] = "ACCIDENT_RECOVERY";
    CARD_SHIPMENT_STATUS_DETAIL["FAILED_DELIVERY_ATTEMPT_LOST"] = "FAILED_DELIVERY_ATTEMPT_LOST";
    CARD_SHIPMENT_STATUS_DETAIL["FAILED_DELIVERY_ATTEMPT_DAMAGED_GOODS"] = "FAILED_DELIVERY_ATTEMPT_DAMAGED_GOODS";
    CARD_SHIPMENT_STATUS_DETAIL["FAILED_DELIVERY_ATTEMPT_STOLEN"] = "FAILED_DELIVERY_ATTEMPT_STOLEN";
    CARD_SHIPMENT_STATUS_DETAIL["RESEND_SHIPMENT"] = "RESEND_SHIPMENT";
    CARD_SHIPMENT_STATUS_DETAIL["START_OF_CUSTODY"] = "START_OF_CUSTODY";
    CARD_SHIPMENT_STATUS_DETAIL["END_OF_CUSTODY"] = "END_OF_CUSTODY";
    CARD_SHIPMENT_STATUS_DETAIL["DISTRIBUTION"] = "DISTRIBUTION";
    CARD_SHIPMENT_STATUS_DETAIL["NOT_DELIVERED"] = "NOT_DELIVERED";
    CARD_SHIPMENT_STATUS_DETAIL["NOT_DELIVERED_INCOMPLETE_ADDRESS"] = "NOT_DELIVERED_INCOMPLETE_ADDRESS";
    CARD_SHIPMENT_STATUS_DETAIL["NOT_DELIVERED_WRONG_ADDRESS"] = "NOT_DELIVERED_WRONG_ADDRESS";
    CARD_SHIPMENT_STATUS_DETAIL["NOT_DELIVERED_ACCIDENT_CLOSED"] = "NOT_DELIVERED_ACCIDENT_CLOSED";
    CARD_SHIPMENT_STATUS_DETAIL["DELIVERED"] = "DELIVERED";
    CARD_SHIPMENT_STATUS_DETAIL["DESTRUCTION"] = "DESTRUCTION";
    CARD_SHIPMENT_STATUS_DETAIL["ACCIDENT"] = "ACCIDENT";
    CARD_SHIPMENT_STATUS_DETAIL["LOST"] = "LOST";
    CARD_SHIPMENT_STATUS_DETAIL["DAMAGED_GOODS"] = "DAMAGED_GOODS";
    CARD_SHIPMENT_STATUS_DETAIL["STOLEN"] = "STOLEN";
})(CARD_SHIPMENT_STATUS_DETAIL || (CARD_SHIPMENT_STATUS_DETAIL = {}));
var CARD_AGENT;
(function (CARD_AGENT) {
    CARD_AGENT["POMELO"] = "Pomelo";
    CARD_AGENT["PRISMA"] = "Prisma";
})(CARD_AGENT || (CARD_AGENT = {}));

var PRECOGS_USER_TAGS;
(function (PRECOGS_USER_TAGS) {
    PRECOGS_USER_TAGS["TNC"] = "tnc";
    PRECOGS_USER_TAGS["HDYHAU"] = "hdyhau";
    PRECOGS_USER_TAGS["PAYMENT_CARD"] = "payment_card";
    PRECOGS_USER_TAGS["PAYMENT_CARD_NO_VALIDATION"] = "payment_card_no_validation";
    PRECOGS_USER_TAGS["ONBOARDING_WELCOME_SEPT_22"] = "onboarding_welcome_sept_22";
    PRECOGS_USER_TAGS["BROKER"] = "broker";
    PRECOGS_USER_TAGS["DOLLARIZE"] = "dollarize";
    PRECOGS_USER_TAGS["ONBOARDING_DOLLARIZE"] = "onboarding_dollarize";
    PRECOGS_USER_TAGS["PJ_CVU"] = "pj-cvu";
    PRECOGS_USER_TAGS["CASHBACK_MENU"] = "cashback_menu";
    PRECOGS_USER_TAGS["CONVERSION"] = "conversion";
    PRECOGS_USER_TAGS["REVIEW_APP"] = "review_app";
    PRECOGS_USER_TAGS["NEW_HOME"] = "new_home";
    PRECOGS_USER_TAGS["PAYMENT_SERVICE"] = "show_payment_service";
    PRECOGS_USER_TAGS["DEACTIVATED_BIOMETRIC"] = "deactivated_biometric";
    PRECOGS_USER_TAGS["CASHBACK_LEVEL_PLUS"] = "nivel-plus";
    PRECOGS_USER_TAGS["CASHBACK_LEVEL_MAX"] = "nivel-max";
    PRECOGS_USER_TAGS["SHOW_CASHBACK_ON_PAYMENT_SERVICE"] = "show_cashback_menu_on_payment_service";
    PRECOGS_USER_TAGS["PAYMENT_SERVICE_TYC"] = "have_seen_payment_service_tyc";
    PRECOGS_USER_TAGS["PAYMENT_CARD_TRANSITION_ONBOARDING"] = "payment_card_transition_onboarding";
    PRECOGS_USER_TAGS["MIDOLAR"] = "midolar";
    PRECOGS_USER_TAGS["DOLARYA"] = "dolarya";
    PRECOGS_USER_TAGS["UNDOLAR"] = "undolar";
    PRECOGS_USER_TAGS["DOLARES"] = "dolares";
    PRECOGS_USER_TAGS["DOLAR_DEFAULT"] = "dolar-default";
    PRECOGS_USER_TAGS["CAN_SEE_FCI"] = "fci-ff";
    PRECOGS_USER_TAGS["CAN_SEE_CASHBACK_CARD_MENU"] = "can_see_cashback_card_menu";
    PRECOGS_USER_TAGS["CAN_SEE_PAYMENT_CARD_TRANSITION"] = "can_see_payment_card_transition";
    PRECOGS_USER_TAGS["HAVE_SEEN_DOLLARIZE_DISCLAIMER"] = "have_seen_dollarize_disclaimer";
    PRECOGS_USER_TAGS["HAVE_SEEN_ONBOARDING_ASESOR"] = "have_seen_onboarding_asesor";
    PRECOGS_USER_TAGS["ASESOR_NACHO"] = "asesor_nacho";
    PRECOGS_USER_TAGS["ASESOR_AGUSTINA"] = "asesor_agustina";
    PRECOGS_USER_TAGS["ASESOR_FELIPE"] = "asesor_felipe";
    PRECOGS_USER_TAGS["SHOW_OLD_PAYMENT_CARDS_DESIGN"] = "show_old_payment_cards_design";
    PRECOGS_USER_TAGS["HOME_PAGE_TOUR"] = "home-page-tour";
    PRECOGS_USER_TAGS["WITHDRAWS_WITH_NEW_CHALLENGES"] = "withdraws_with_new_challenges";
    PRECOGS_USER_TAGS["LOCAL_MARKET"] = "local_market";
    PRECOGS_USER_TAGS["ARBITRAJISTA"] = "arbitrajista";
    PRECOGS_USER_TAGS["CAN_SEE_HOME_NEWS_BUTTON"] = "can_see_home_news_button";
    PRECOGS_USER_TAGS["HAVE_SEEN_MARKETS_NEWS_HOME_BUTTON"] = "have_seen_markets_news_home_button";
})(PRECOGS_USER_TAGS || (PRECOGS_USER_TAGS = {}));
var PRECOGS_USER_ROLES;
(function (PRECOGS_USER_ROLES) {
    PRECOGS_USER_ROLES["MEMBER"] = "member";
    PRECOGS_USER_ROLES["ADMIN"] = "admin";
    PRECOGS_USER_ROLES["SUPERADMIN"] = "superadmin";
    PRECOGS_USER_ROLES["TRADER"] = "trader";
    PRECOGS_USER_ROLES["PARTNER"] = "partner";
})(PRECOGS_USER_ROLES || (PRECOGS_USER_ROLES = {}));
var PRECOGS_USER_REFERRER_TYPE;
(function (PRECOGS_USER_REFERRER_TYPE) {
    PRECOGS_USER_REFERRER_TYPE["USER_REFERRER"] = "USER_REFERRER";
    PRECOGS_USER_REFERRER_TYPE["PROMOTION_CODE"] = "PROMOTION_CODE";
})(PRECOGS_USER_REFERRER_TYPE || (PRECOGS_USER_REFERRER_TYPE = {}));
var PRECOGS_FLAG_FORM_TYPE;
(function (PRECOGS_FLAG_FORM_TYPE) {
    PRECOGS_FLAG_FORM_TYPE["RADIO_GROUP"] = "RADIO_GROUP";
    PRECOGS_FLAG_FORM_TYPE["INPUT"] = "INPUT";
    PRECOGS_FLAG_FORM_TYPE["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    PRECOGS_FLAG_FORM_TYPE["OPTION_SELECTOR"] = "OPTION_SELECTOR";
    PRECOGS_FLAG_FORM_TYPE["TOGGLE"] = "TOGGLE";
    PRECOGS_FLAG_FORM_TYPE["DATE_PICKER"] = "DATE_PICKER";
})(PRECOGS_FLAG_FORM_TYPE || (PRECOGS_FLAG_FORM_TYPE = {}));
var PRECOGS_FLAG_TYPE;
(function (PRECOGS_FLAG_TYPE) {
    PRECOGS_FLAG_TYPE["ONE_TIME_VIEW"] = "one_time_view";
    PRECOGS_FLAG_TYPE["TIME_SEPARATED"] = "time_separated";
    PRECOGS_FLAG_TYPE["LOGIN_SEPARATED"] = "login_separated";
})(PRECOGS_FLAG_TYPE || (PRECOGS_FLAG_TYPE = {}));
var FLAG_FORM_INPUT_TYPE;
(function (FLAG_FORM_INPUT_TYPE) {
    FLAG_FORM_INPUT_TYPE["string"] = "string";
    FLAG_FORM_INPUT_TYPE["number"] = "number";
})(FLAG_FORM_INPUT_TYPE || (FLAG_FORM_INPUT_TYPE = {}));
var PRECOGS_CONFIG_ASSETS_CATEGORIES_VIEW;
(function (PRECOGS_CONFIG_ASSETS_CATEGORIES_VIEW) {
    PRECOGS_CONFIG_ASSETS_CATEGORIES_VIEW["HOME"] = "home";
    PRECOGS_CONFIG_ASSETS_CATEGORIES_VIEW["MARKET"] = "market";
})(PRECOGS_CONFIG_ASSETS_CATEGORIES_VIEW || (PRECOGS_CONFIG_ASSETS_CATEGORIES_VIEW = {}));
var PRECOGS_CONFIG_ASSETS_CATEGORIES_TYPE;
(function (PRECOGS_CONFIG_ASSETS_CATEGORIES_TYPE) {
    PRECOGS_CONFIG_ASSETS_CATEGORIES_TYPE["SECURITY"] = "security";
    PRECOGS_CONFIG_ASSETS_CATEGORIES_TYPE["CURRENCY"] = "currency";
})(PRECOGS_CONFIG_ASSETS_CATEGORIES_TYPE || (PRECOGS_CONFIG_ASSETS_CATEGORIES_TYPE = {}));

var ADJUSTMENT_STATUS;
(function (ADJUSTMENT_STATUS) {
    ADJUSTMENT_STATUS["PENDING"] = "pending";
    ADJUSTMENT_STATUS["AUTHORIZED"] = "authorized";
    ADJUSTMENT_STATUS["REJECTED"] = "rejected";
    ADJUSTMENT_STATUS["SYNC_FAILED"] = "sync_failed";
})(ADJUSTMENT_STATUS || (ADJUSTMENT_STATUS = {}));
var ADJUSTMENT_SUBCATEGORY_TYPE;
(function (ADJUSTMENT_SUBCATEGORY_TYPE) {
    ADJUSTMENT_SUBCATEGORY_TYPE["CREDIT"] = "credit";
    ADJUSTMENT_SUBCATEGORY_TYPE["DEBIT"] = "debit";
})(ADJUSTMENT_SUBCATEGORY_TYPE || (ADJUSTMENT_SUBCATEGORY_TYPE = {}));
var ADJUSTMENT_SUBCATEGORY_NAME;
(function (ADJUSTMENT_SUBCATEGORY_NAME) {
    ADJUSTMENT_SUBCATEGORY_NAME["SALARY"] = "salary";
    ADJUSTMENT_SUBCATEGORY_NAME["BONUS"] = "bonus";
    ADJUSTMENT_SUBCATEGORY_NAME["DEPOSIT_DESK"] = "deposit_desk";
    ADJUSTMENT_SUBCATEGORY_NAME["WITHDRAW_DESK"] = "withdraw_desk";
    ADJUSTMENT_SUBCATEGORY_NAME["FEE"] = "fee";
    ADJUSTMENT_SUBCATEGORY_NAME["ADJUSTMENT"] = "adjustment";
    ADJUSTMENT_SUBCATEGORY_NAME["AIRDROP"] = "airdrop";
    ADJUSTMENT_SUBCATEGORY_NAME["MIGRATION"] = "migration";
    ADJUSTMENT_SUBCATEGORY_NAME["SERVICE_COST"] = "service_cost";
    ADJUSTMENT_SUBCATEGORY_NAME["GIFT"] = "gift";
    ADJUSTMENT_SUBCATEGORY_NAME["CASHBACK"] = "cashback";
    ADJUSTMENT_SUBCATEGORY_NAME["PROMOTION"] = "promotion";
    ADJUSTMENT_SUBCATEGORY_NAME["COMPENSATION"] = "compensation";
})(ADJUSTMENT_SUBCATEGORY_NAME || (ADJUSTMENT_SUBCATEGORY_NAME = {}));

var INVESTMENT_STATE;
(function (INVESTMENT_STATE) {
    INVESTMENT_STATE["ACTIVE"] = "active";
    INVESTMENT_STATE["INACTIVE"] = "inactive";
    INVESTMENT_STATE["PENDING"] = "pending";
})(INVESTMENT_STATE || (INVESTMENT_STATE = {}));

var REWARDS_CAMPAINGS;
(function (REWARDS_CAMPAINGS) {
    REWARDS_CAMPAINGS["REFERRALS"] = "Referido";
    REWARDS_CAMPAINGS["CASHBACK"] = "Cashback";
    REWARDS_CAMPAINGS["CASHBACK_CARD"] = "Cashback Crypto";
    REWARDS_CAMPAINGS["CASHBACK_PAYMENT_SERVICE"] = "Cashback Pago de Servicios";
    REWARDS_CAMPAINGS["CASHBACK_PAYMENT_CARD_02_2024"] = "Cashback Tarjeta Febrero 2024";
    REWARDS_CAMPAINGS["CASHBACK_REFERRALS_MAY"] = "referidos_tarjetas_mayo";
    REWARDS_CAMPAINGS["CASHBACK_MERK_2025"] = "cashback-merk-2025";
})(REWARDS_CAMPAINGS || (REWARDS_CAMPAINGS = {}));
var PAYMENT_CONDITIONS_OPTIONS;
(function (PAYMENT_CONDITIONS_OPTIONS) {
    PAYMENT_CONDITIONS_OPTIONS["PER_ACTION"] = "per_action";
    PAYMENT_CONDITIONS_OPTIONS["ALL_ACTIONS"] = "all_actions";
})(PAYMENT_CONDITIONS_OPTIONS || (PAYMENT_CONDITIONS_OPTIONS = {}));
var CAMPAIGN_STATUS_OPTIONS;
(function (CAMPAIGN_STATUS_OPTIONS) {
    CAMPAIGN_STATUS_OPTIONS["ACTIVE"] = "active";
    CAMPAIGN_STATUS_OPTIONS["DISABLED"] = "disabled";
})(CAMPAIGN_STATUS_OPTIONS || (CAMPAIGN_STATUS_OPTIONS = {}));
var REWARD_PAYMENT_STATUS_OPTIONS;
(function (REWARD_PAYMENT_STATUS_OPTIONS) {
    REWARD_PAYMENT_STATUS_OPTIONS["PENDING"] = "pending";
    REWARD_PAYMENT_STATUS_OPTIONS["COMPLETED"] = "completed";
    REWARD_PAYMENT_STATUS_OPTIONS["SYNC_FAILED"] = "sync_failed";
    REWARD_PAYMENT_STATUS_OPTIONS["ADMIN_REQUIRED"] = "admin_required";
    REWARD_PAYMENT_STATUS_OPTIONS["CANCELED"] = "canceled";
    REWARD_PAYMENT_STATUS_OPTIONS["REVOKED"] = "revoked";
})(REWARD_PAYMENT_STATUS_OPTIONS || (REWARD_PAYMENT_STATUS_OPTIONS = {}));

var Platform;
(function (Platform) {
    Platform["ANDROID"] = "android";
    Platform["IOS"] = "ios";
    Platform["BROWSER"] = "browser";
})(Platform || (Platform = {}));
var LoginMethods;
(function (LoginMethods) {
    LoginMethods["WEBAUTHN"] = "webauthn";
    LoginMethods["PASSWORD"] = "password";
    LoginMethods["OIDC"] = "oidc";
    LoginMethods["OTP"] = "otp";
    LoginMethods["INVITE"] = "invite";
})(LoginMethods || (LoginMethods = {}));
var FlowTypes;
(function (FlowTypes) {
    FlowTypes["API"] = "api";
    FlowTypes["BROWSER"] = "browser";
})(FlowTypes || (FlowTypes = {}));
var AuthorizationStatus;
(function (AuthorizationStatus) {
    AuthorizationStatus["PENDING"] = "pending";
    AuthorizationStatus["ACCEPTED"] = "accepted";
    AuthorizationStatus["REJECTED"] = "rejected";
    AuthorizationStatus["EXPIRED"] = "expired";
})(AuthorizationStatus || (AuthorizationStatus = {}));
var AuthorizationAction;
(function (AuthorizationAction) {
    AuthorizationAction["ACCEPT"] = "accept";
    AuthorizationAction["REJECT"] = "reject";
})(AuthorizationAction || (AuthorizationAction = {}));
var AuthorizationType;
(function (AuthorizationType) {
    AuthorizationType["SESSION"] = "session_authorization";
    AuthorizationType["WITHDRAW"] = "withdraw_authorization";
})(AuthorizationType || (AuthorizationType = {}));
var LoginSteps;
(function (LoginSteps) {
    LoginSteps["SESSION_AUTHORIZATION"] = "session_authorization";
    LoginSteps["OTP_REQUIRED"] = "otp_required";
    LoginSteps["DEVICE_ENROLLMENT_REQUIRED"] = "device_enrollment_required";
})(LoginSteps || (LoginSteps = {}));
var PERMISSION_STATE;
(function (PERMISSION_STATE) {
    PERMISSION_STATE["VIEWER"] = "viewer";
    PERMISSION_STATE["ADMIN"] = "admin";
    PERMISSION_STATE["OWNER"] = "owner";
    PERMISSION_STATE["REVOKED"] = "revoked";
})(PERMISSION_STATE || (PERMISSION_STATE = {}));
var ACCOUNT_INVITE_STATUS;
(function (ACCOUNT_INVITE_STATUS) {
    ACCOUNT_INVITE_STATUS["SENT"] = "sent";
    ACCOUNT_INVITE_STATUS["ACCEPTED"] = "accepted";
    ACCOUNT_INVITE_STATUS["REJECTED"] = "rejected";
    ACCOUNT_INVITE_STATUS["CONFIRMED"] = "confirmed";
})(ACCOUNT_INVITE_STATUS || (ACCOUNT_INVITE_STATUS = {}));
var CHALLENGE_METHODS;
(function (CHALLENGE_METHODS) {
    CHALLENGE_METHODS["OUT_OF_BAND"] = "out_of_band";
    CHALLENGE_METHODS["WEBAUTHN"] = "webauthn";
    CHALLENGE_METHODS["OTP"] = "otp";
})(CHALLENGE_METHODS || (CHALLENGE_METHODS = {}));
var CHALLENGE_STATUS;
(function (CHALLENGE_STATUS) {
    CHALLENGE_STATUS["PENDING"] = "pending";
    CHALLENGE_STATUS["ACCEPTED"] = "accepted";
    CHALLENGE_STATUS["FAILED"] = "failed";
})(CHALLENGE_STATUS || (CHALLENGE_STATUS = {}));

var RULE_EVENT_STATUS;
(function (RULE_EVENT_STATUS) {
    RULE_EVENT_STATUS["DISABLED"] = "disabled";
    RULE_EVENT_STATUS["ACTIVE"] = "active";
})(RULE_EVENT_STATUS || (RULE_EVENT_STATUS = {}));
var RULE_STATUS;
(function (RULE_STATUS) {
    RULE_STATUS["DISABLED"] = "disabled";
    RULE_STATUS["ACTIVE"] = "active";
})(RULE_STATUS || (RULE_STATUS = {}));
var RULE_TARJET_STATUS;
(function (RULE_TARJET_STATUS) {
    RULE_TARJET_STATUS["DISABLED"] = "disabled";
    RULE_TARJET_STATUS["ACTIVE"] = "active";
})(RULE_TARJET_STATUS || (RULE_TARJET_STATUS = {}));
var RULE_EXECUTION_STATUS;
(function (RULE_EXECUTION_STATUS) {
    RULE_EXECUTION_STATUS["SUBMITTED"] = "submitted";
    RULE_EXECUTION_STATUS["SUCCEED"] = "succeed";
    RULE_EXECUTION_STATUS["FAILED"] = "failed";
})(RULE_EXECUTION_STATUS || (RULE_EXECUTION_STATUS = {}));
var RULE_EVENT_ID;
(function (RULE_EVENT_ID) {
    RULE_EVENT_ID["DEPOSITS"] = "payments_system.deposit.created";
    RULE_EVENT_ID["CASHBACK"] = "rewards_system.payment.created";
    RULE_EVENT_ID["INVEST"] = "interest_system.accounting_record.created";
})(RULE_EVENT_ID || (RULE_EVENT_ID = {}));

var events = {};

(function (exports) {

const ADJUSTMENTS_SERVICE_NAME = "caronte";
const ADJUSTMENTS_ADJUSTMENT_TYPE = `${ADJUSTMENTS_SERVICE_NAME}.adjustments`;
exports.AdjustmentsStateStates = void 0;
(function (AdjustmentsStateStates) {
    AdjustmentsStateStates["PENDING"] = "pending";
    AdjustmentsStateStates["AUTHORIZED"] = "authorized";
    AdjustmentsStateStates["REJECTED"] = "rejected";
    AdjustmentsStateStates["SUCCEED"] = "sync_failed";
})(exports.AdjustmentsStateStates || (exports.AdjustmentsStateStates = {}));

const BROKER_SERVICE_NAME = "broker";
const BROKER_SWAP_TYPE = `${BROKER_SERVICE_NAME}.swaps`;
const BROKER_AUTOSWAP_ALCHEMIST_TYPE = `${BROKER_SERVICE_NAME}.autoswaps.alchemist`;
const BROKER_AUTOSWAP_PAYMENTS_TYPE = `${BROKER_SERVICE_NAME}.autoswaps.payments`;
const BROKER_AUTOSWAP_KAIBACORP_TYPE = `${BROKER_SERVICE_NAME}.autoswaps.kaibacorp`;
const BROKER_DOLLARIZE_TYPE = `${BROKER_SERVICE_NAME}.dollarize`;
exports.BrokerSwapStates = void 0;
(function (BrokerSwapStates) {
    BrokerSwapStates["PENDING"] = "pending";
    BrokerSwapStates["PROCESSING"] = "processing";
    BrokerSwapStates["RELEASE_FUNDS"] = "release-funds";
    BrokerSwapStates["FAILED_TO_RELEASE_FUNDS"] = "failed-to-release-funds";
    BrokerSwapStates["REJECTED"] = "rejected";
    BrokerSwapStates["SUCCEED"] = "succeed";
    BrokerSwapStates["ACCEPTED"] = "accepted";
    BrokerSwapStates["FAILED_TO_EXECUTE"] = "failed-to-execute";
})(exports.BrokerSwapStates || (exports.BrokerSwapStates = {}));

const INTERESTS_SERVICE_NAME = "interests";
const INTERESTS_ACCOUNTING_RECORD_TYPE = `${INTERESTS_SERVICE_NAME}.accounting_record`;
exports.InterestsAccountingRecordStates = void 0;
(function (InterestsAccountingRecordStates) {
    InterestsAccountingRecordStates["PENDING"] = "pending";
    InterestsAccountingRecordStates["PROCESSED"] = "processed";
    InterestsAccountingRecordStates["SUCCEEDED"] = "succeeded";
    InterestsAccountingRecordStates["BELOW_MIN"] = "below_min";
})(exports.InterestsAccountingRecordStates || (exports.InterestsAccountingRecordStates = {}));

const KAIBACORP_SERVICE_NAME = "kaibacorp";
const KAIBA_TRANSACTION_TYPE = `${KAIBACORP_SERVICE_NAME}.transaction`;
exports.KaibaTransactionStates = void 0;
(function (KaibaTransactionStates) {
    KaibaTransactionStates["HELD"] = "held";
    KaibaTransactionStates["APPROVED"] = "approved";
    KaibaTransactionStates["REJECT"] = "rejected";
    KaibaTransactionStates["SYNC_FAIL"] = "sync_failed";
})(exports.KaibaTransactionStates || (exports.KaibaTransactionStates = {}));

const PAYMENTS_SERVICE_NAME = "payments";
const PAYMENTS_DEPOSIT_TYPE = `${PAYMENTS_SERVICE_NAME}.deposit`;
const PAYMENTS_WITHDRAW_TYPE = `${PAYMENTS_SERVICE_NAME}.withdraw`;
const PAYMENTS_WITHHOLDING_TYPE = `${PAYMENTS_SERVICE_NAME}.withholding`;
exports.PaymentsWithdrawStates = void 0;
(function (PaymentsWithdrawStates) {
    PaymentsWithdrawStates["PREPARED"] = "prepared";
    PaymentsWithdrawStates["SUBMITTED"] = "submitted";
    PaymentsWithdrawStates["PROCESSING"] = "processing";
    PaymentsWithdrawStates["SUCCEED"] = "succeed";
    PaymentsWithdrawStates["FAILED"] = "failed";
    PaymentsWithdrawStates["CONFIRMING"] = "confirming";
    PaymentsWithdrawStates["ERRORED"] = "errored";
    PaymentsWithdrawStates["SYNC_FAILED"] = "sync_failed";
})(exports.PaymentsWithdrawStates || (exports.PaymentsWithdrawStates = {}));
exports.PaymentsDepositStates = void 0;
(function (PaymentsDepositStates) {
    PaymentsDepositStates["SUBMITTED"] = "submitted";
    PaymentsDepositStates["BELOW_MIN"] = "below_min";
    PaymentsDepositStates["BENEFICIARY_BLOCKED"] = "beneficiary_blocked";
    PaymentsDepositStates["BLOCKED"] = "blocked";
    PaymentsDepositStates["ACCEPTED"] = "accepted";
    PaymentsDepositStates["REJECTED"] = "rejected";
    PaymentsDepositStates["SYNC_FAILED"] = "sync_failed";
    PaymentsDepositStates["NOT_ALLOWED"] = "not_allowed";
})(exports.PaymentsDepositStates || (exports.PaymentsDepositStates = {}));

const PEATIO_SERVICE_NAME = "peatio";
const PEATIO_ORDER_TYPE = `${PEATIO_SERVICE_NAME}.order`;
exports.PeatioOrderStates = void 0;
(function (PeatioOrderStates) {
    PeatioOrderStates["CANCELED"] = "canceled";
    PeatioOrderStates["COMPLETED"] = "completed";
    PeatioOrderStates["OPEN"] = "open";
    PeatioOrderStates["ERROR"] = "error";
})(exports.PeatioOrderStates || (exports.PeatioOrderStates = {}));

const REFERRAL_PROGRAM_SERVICE_NAME = "referral_program";
const REFERRAL_PROGRAM_PAYOUT_TYPE = `${REFERRAL_PROGRAM_SERVICE_NAME}.payout`;
exports.ReferralProgramPayoutStates = void 0;
(function (ReferralProgramPayoutStates) {
    ReferralProgramPayoutStates["SUBMITTED"] = "submitted";
    ReferralProgramPayoutStates["SUCCEEDED"] = "succeeded";
    ReferralProgramPayoutStates["REJECTED"] = "rejected";
})(exports.ReferralProgramPayoutStates || (exports.ReferralProgramPayoutStates = {}));

const REWARDS_SERVICE_NAME = "rewards";
const REWARDS_PAYMENTS_TYPE = `${REWARDS_SERVICE_NAME}.payment`;
exports.RewardsPaymentsStates = void 0;
(function (RewardsPaymentsStates) {
    RewardsPaymentsStates["PENDING"] = "pending";
    RewardsPaymentsStates["COMPLETED"] = "completed";
    RewardsPaymentsStates["SYNC_FAILED"] = "sync_failed";
    RewardsPaymentsStates["ADMIN_REQUIRED"] = "admin_required";
    RewardsPaymentsStates["REVOKED"] = "revoked";
    RewardsPaymentsStates["CANCELED"] = "canceled";
})(exports.RewardsPaymentsStates || (exports.RewardsPaymentsStates = {}));
exports.RewardsProviders = void 0;
(function (RewardsProviders) {
    RewardsProviders["PEATIO"] = "peatio";
    RewardsProviders["MERK"] = "merk";
})(exports.RewardsProviders || (exports.RewardsProviders = {}));

const ALCHEMIST_SERVICE_NAME = "alchemist";
const ALCHEMIST_RULE_EXECUTION_TYPE = `${ALCHEMIST_SERVICE_NAME}.rule_execution`;
exports.AlchemistRuleExecutionStates = void 0;
(function (AlchemistRuleExecutionStates) {
    AlchemistRuleExecutionStates["SUBMITTED"] = "submitted";
    AlchemistRuleExecutionStates["FAILED"] = "failed";
    AlchemistRuleExecutionStates["SUCCEED"] = "succeed";
})(exports.AlchemistRuleExecutionStates || (exports.AlchemistRuleExecutionStates = {}));

const SR_BARRIGA_SERVICE_NAME = "srbarriga";
const SR_BARRIGA_PAYMENT_TYPE = `${SR_BARRIGA_SERVICE_NAME}.payment`;
exports.SrBarrigaPaymentStates = void 0;
(function (SrBarrigaPaymentStates) {
    SrBarrigaPaymentStates["SUCCEED"] = "succeed";
    SrBarrigaPaymentStates["FAILED"] = "failed";
})(exports.SrBarrigaPaymentStates || (exports.SrBarrigaPaymentStates = {}));

const WITHHOLDINGS_SERVICE_NAME = "withholdings";
const WITHHOLDINGS_WITHHOLDINGS_TYPE = `${WITHHOLDINGS_SERVICE_NAME}.withholdings`;
exports.WITHHOLDINGS_WITHHOLDING_STATUS = void 0;
(function (WITHHOLDINGS_WITHHOLDING_STATUS) {
    WITHHOLDINGS_WITHHOLDING_STATUS["PAID"] = "paid";
    WITHHOLDINGS_WITHHOLDING_STATUS["UNPAID"] = "unpaid";
    WITHHOLDINGS_WITHHOLDING_STATUS["SYNC_FAILED"] = "sync_failed";
    WITHHOLDINGS_WITHHOLDING_STATUS["EXEMPT"] = "exempt";
})(exports.WITHHOLDINGS_WITHHOLDING_STATUS || (exports.WITHHOLDINGS_WITHHOLDING_STATUS = {}));

const MERK_SERVICE_NAME = "merk";
const MERK_ACCOUNT_MOVEMENT_RECORD_TYPE = `${MERK_SERVICE_NAME}.account_movement`;
const MERK_DEBIT_ACCOUNT_MOVEMENT_RECORD_TYPE = `${MERK_SERVICE_NAME}.account_movement.debit`;
const MERK_CREDIT_ACCOUNT_MOVEMENT_RECORD_TYPE = `${MERK_SERVICE_NAME}.account_movement.credit`;
const MERK_ORDER_TYPE = `${MERK_SERVICE_NAME}.order`;
exports.MerkAccountMovementType = void 0;
(function (MerkAccountMovementType) {
    MerkAccountMovementType["Debit"] = "debit";
    MerkAccountMovementType["Credit"] = "credit";
})(exports.MerkAccountMovementType || (exports.MerkAccountMovementType = {}));
exports.MerkApiProvider = void 0;
(function (MerkApiProvider) {
    MerkApiProvider["ALPACA"] = "alpaca";
    MerkApiProvider["ESCO"] = "esco";
})(exports.MerkApiProvider || (exports.MerkApiProvider = {}));

exports.ADJUSTMENTS_ADJUSTMENT_TYPE = ADJUSTMENTS_ADJUSTMENT_TYPE;
exports.ADJUSTMENTS_SERVICE_NAME = ADJUSTMENTS_SERVICE_NAME;
exports.ALCHEMIST_RULE_EXECUTION_TYPE = ALCHEMIST_RULE_EXECUTION_TYPE;
exports.ALCHEMIST_SERVICE_NAME = ALCHEMIST_SERVICE_NAME;
exports.BROKER_AUTOSWAP_ALCHEMIST_TYPE = BROKER_AUTOSWAP_ALCHEMIST_TYPE;
exports.BROKER_AUTOSWAP_KAIBACORP_TYPE = BROKER_AUTOSWAP_KAIBACORP_TYPE;
exports.BROKER_AUTOSWAP_PAYMENTS_TYPE = BROKER_AUTOSWAP_PAYMENTS_TYPE;
exports.BROKER_DOLLARIZE_TYPE = BROKER_DOLLARIZE_TYPE;
exports.BROKER_SERVICE_NAME = BROKER_SERVICE_NAME;
exports.BROKER_SWAP_TYPE = BROKER_SWAP_TYPE;
exports.INTERESTS_ACCOUNTING_RECORD_TYPE = INTERESTS_ACCOUNTING_RECORD_TYPE;
exports.INTERESTS_SERVICE_NAME = INTERESTS_SERVICE_NAME;
exports.KAIBACORP_SERVICE_NAME = KAIBACORP_SERVICE_NAME;
exports.KAIBA_TRANSACTION_TYPE = KAIBA_TRANSACTION_TYPE;
exports.MERK_ACCOUNT_MOVEMENT_RECORD_TYPE = MERK_ACCOUNT_MOVEMENT_RECORD_TYPE;
exports.MERK_CREDIT_ACCOUNT_MOVEMENT_RECORD_TYPE = MERK_CREDIT_ACCOUNT_MOVEMENT_RECORD_TYPE;
exports.MERK_DEBIT_ACCOUNT_MOVEMENT_RECORD_TYPE = MERK_DEBIT_ACCOUNT_MOVEMENT_RECORD_TYPE;
exports.MERK_ORDER_TYPE = MERK_ORDER_TYPE;
exports.MERK_SERVICE_NAME = MERK_SERVICE_NAME;
exports.PAYMENTS_DEPOSIT_TYPE = PAYMENTS_DEPOSIT_TYPE;
exports.PAYMENTS_SERVICE_NAME = PAYMENTS_SERVICE_NAME;
exports.PAYMENTS_WITHDRAW_TYPE = PAYMENTS_WITHDRAW_TYPE;
exports.PAYMENTS_WITHHOLDING_TYPE = PAYMENTS_WITHHOLDING_TYPE;
exports.PEATIO_ORDER_TYPE = PEATIO_ORDER_TYPE;
exports.PEATIO_SERVICE_NAME = PEATIO_SERVICE_NAME;
exports.REFERRAL_PROGRAM_PAYOUT_TYPE = REFERRAL_PROGRAM_PAYOUT_TYPE;
exports.REFERRAL_PROGRAM_SERVICE_NAME = REFERRAL_PROGRAM_SERVICE_NAME;
exports.REWARDS_PAYMENTS_TYPE = REWARDS_PAYMENTS_TYPE;
exports.REWARDS_SERVICE_NAME = REWARDS_SERVICE_NAME;
exports.SR_BARRIGA_PAYMENT_TYPE = SR_BARRIGA_PAYMENT_TYPE;
exports.SR_BARRIGA_SERVICE_NAME = SR_BARRIGA_SERVICE_NAME;
exports.WITHHOLDINGS_SERVICE_NAME = WITHHOLDINGS_SERVICE_NAME;
exports.WITHHOLDINGS_WITHHOLDINGS_TYPE = WITHHOLDINGS_WITHHOLDINGS_TYPE;

}(events));

var RECORD_STATE;
(function (RECORD_STATE) {
    RECORD_STATE["SUCCEED"] = "succeed";
    RECORD_STATE["FAILED"] = "failed";
    RECORD_STATE["PENDING"] = "pending";
    RECORD_STATE["WAITING_AUTHORIZATION"] = "waiting_authorization";
    RECORD_STATE["EXPIRED"] = "expired";
    RECORD_STATE["UNAUTHORIZED"] = "unauthorized";
})(RECORD_STATE || (RECORD_STATE = {}));

var TokenType;
(function (TokenType) {
    TokenType["ADID"] = "adjust";
    TokenType["FCM"] = "fcm";
    TokenType["ANDROID_ADID"] = "android_adid";
    TokenType["IOS_IDFA"] = "ios_idfa";
})(TokenType || (TokenType = {}));

var ORDER_SUBSCRIPTION_PAYMENTS;
(function (ORDER_SUBSCRIPTION_PAYMENTS) {
    ORDER_SUBSCRIPTION_PAYMENTS["NAME"] = "name";
    ORDER_SUBSCRIPTION_PAYMENTS["PONDERANCE"] = "ponderance";
})(ORDER_SUBSCRIPTION_PAYMENTS || (ORDER_SUBSCRIPTION_PAYMENTS = {}));
var AMOUNT_VALUE_ALLOWED_COMPANY;
(function (AMOUNT_VALUE_ALLOWED_COMPANY) {
    AMOUNT_VALUE_ALLOWED_COMPANY["EQUAL"] = "equal";
    AMOUNT_VALUE_ALLOWED_COMPANY["GREATER_OR_EQUAL"] = "greater_or_equal";
    AMOUNT_VALUE_ALLOWED_COMPANY["ANY"] = "any";
    AMOUNT_VALUE_ALLOWED_COMPANY["UNKNOWN"] = "unknown";
})(AMOUNT_VALUE_ALLOWED_COMPANY || (AMOUNT_VALUE_ALLOWED_COMPANY = {}));
var TYPE_COMPANY;
(function (TYPE_COMPANY) {
    TYPE_COMPANY["RECHARGE"] = "recharge";
    TYPE_COMPANY["DEBT"] = "debt";
    TYPE_COMPANY["ONLY_INVOICE"] = "only_invoice";
})(TYPE_COMPANY || (TYPE_COMPANY = {}));
var RECHARGE_TYPE_COMPANY;
(function (RECHARGE_TYPE_COMPANY) {
    RECHARGE_TYPE_COMPANY["CELLPHONE"] = "celular";
    RECHARGE_TYPE_COMPANY["TRANSPORT"] = "transporte";
    RECHARGE_TYPE_COMPANY["PREPAID"] = "prepagos";
})(RECHARGE_TYPE_COMPANY || (RECHARGE_TYPE_COMPANY = {}));
var PAYMENT_STATUS_SUBSCRIPTION_PAYMENT;
(function (PAYMENT_STATUS_SUBSCRIPTION_PAYMENT) {
    PAYMENT_STATUS_SUBSCRIPTION_PAYMENT["PENDING"] = "pending";
    PAYMENT_STATUS_SUBSCRIPTION_PAYMENT["PREPARED"] = "prepared";
    PAYMENT_STATUS_SUBSCRIPTION_PAYMENT["PROCESSING"] = "processing";
    PAYMENT_STATUS_SUBSCRIPTION_PAYMENT["SUCCEED"] = "succeed";
    PAYMENT_STATUS_SUBSCRIPTION_PAYMENT["FAILED"] = "failed";
    PAYMENT_STATUS_SUBSCRIPTION_PAYMENT["SYNC_FAILED"] = "sync_failed";
})(PAYMENT_STATUS_SUBSCRIPTION_PAYMENT || (PAYMENT_STATUS_SUBSCRIPTION_PAYMENT = {}));
var SUBSCRIPTION_STATUS_SUBSCRIPTION_PAYMENTS;
(function (SUBSCRIPTION_STATUS_SUBSCRIPTION_PAYMENTS) {
    SUBSCRIPTION_STATUS_SUBSCRIPTION_PAYMENTS["ARCHIVE"] = "archive";
    SUBSCRIPTION_STATUS_SUBSCRIPTION_PAYMENTS["ACTIVATE"] = "activate";
})(SUBSCRIPTION_STATUS_SUBSCRIPTION_PAYMENTS || (SUBSCRIPTION_STATUS_SUBSCRIPTION_PAYMENTS = {}));
var ACTION_TYPE_BARCODE_DEBT_DETAILS;
(function (ACTION_TYPE_BARCODE_DEBT_DETAILS) {
    ACTION_TYPE_BARCODE_DEBT_DETAILS["SELECT_COMPANY"] = "select_company";
    ACTION_TYPE_BARCODE_DEBT_DETAILS["SHOW_INVOICE"] = "show_invoice";
})(ACTION_TYPE_BARCODE_DEBT_DETAILS || (ACTION_TYPE_BARCODE_DEBT_DETAILS = {}));

var CREDIT_NOTE_STATE;
(function (CREDIT_NOTE_STATE) {
    CREDIT_NOTE_STATE["CREATED"] = "created";
    CREDIT_NOTE_STATE["WAITING"] = "waiting";
    CREDIT_NOTE_STATE["SUCCEED"] = "succeed";
    CREDIT_NOTE_STATE["FAILED"] = "failed";
    CREDIT_NOTE_STATE["SYNC_FAILED"] = "sync_failed";
})(CREDIT_NOTE_STATE || (CREDIT_NOTE_STATE = {}));
var INVOICE_WITHHOLDING_TAX_CONDITION;
(function (INVOICE_WITHHOLDING_TAX_CONDITION) {
    INVOICE_WITHHOLDING_TAX_CONDITION["FOREIGN"] = "foreign";
    INVOICE_WITHHOLDING_TAX_CONDITION["FINAL_CONSUMER"] = "final_consumer";
    INVOICE_WITHHOLDING_TAX_CONDITION["EXEMPT"] = "exempt";
    INVOICE_WITHHOLDING_TAX_CONDITION["SINGLETAX"] = "singletax";
    INVOICE_WITHHOLDING_TAX_CONDITION["REGISTERED_REPONSIBLE"] = "registered_responsible";
})(INVOICE_WITHHOLDING_TAX_CONDITION || (INVOICE_WITHHOLDING_TAX_CONDITION = {}));
var INVOICE_OPERATION_STATE;
(function (INVOICE_OPERATION_STATE) {
    INVOICE_OPERATION_STATE["ACTIVE"] = "active";
    INVOICE_OPERATION_STATE["ARCHIVE"] = "archived";
    INVOICE_OPERATION_STATE["CANCELLED"] = "cancelled";
})(INVOICE_OPERATION_STATE || (INVOICE_OPERATION_STATE = {}));
var INVOICE_WITHHOLDING_STATE;
(function (INVOICE_WITHHOLDING_STATE) {
    INVOICE_WITHHOLDING_STATE["CREATED"] = "created";
    INVOICE_WITHHOLDING_STATE["SUCCEED"] = "succeed";
    INVOICE_WITHHOLDING_STATE["FAILED"] = "failed";
    INVOICE_WITHHOLDING_STATE["SYNC_FAILED"] = "sync_failed";
    INVOICE_WITHHOLDING_STATE["PENDING"] = "pending";
})(INVOICE_WITHHOLDING_STATE || (INVOICE_WITHHOLDING_STATE = {}));
var INVOICE_WITHHOLDING_TYPE;
(function (INVOICE_WITHHOLDING_TYPE) {
    INVOICE_WITHHOLDING_TYPE["AFIP_A"] = "afip_A";
    INVOICE_WITHHOLDING_TYPE["AFIP_B"] = "afip_B";
    INVOICE_WITHHOLDING_TYPE["AFIP_C"] = "afip_C";
    INVOICE_WITHHOLDING_TYPE["FOREIGN"] = "foreign";
})(INVOICE_WITHHOLDING_TYPE || (INVOICE_WITHHOLDING_TYPE = {}));
var GET_INVOICE_TYPE;
(function (GET_INVOICE_TYPE) {
    GET_INVOICE_TYPE["CARD_TRANSACTION"] = "card_transaction";
    GET_INVOICE_TYPE["SWAP"] = "swap";
    GET_INVOICE_TYPE["DEPOSIT"] = "deposit";
    GET_INVOICE_TYPE["WITHDRAW"] = "withdraw";
})(GET_INVOICE_TYPE || (GET_INVOICE_TYPE = {}));
var GET_INVOICE_SERVICE;
(function (GET_INVOICE_SERVICE) {
    GET_INVOICE_SERVICE["KAIBACORP"] = "kaibacorp";
    GET_INVOICE_SERVICE["BROKER"] = "broker";
    GET_INVOICE_SERVICE["PAYMENTS"] = "payments";
})(GET_INVOICE_SERVICE || (GET_INVOICE_SERVICE = {}));

var ACCOUNT_PROVIDERS;
(function (ACCOUNT_PROVIDERS) {
    ACCOUNT_PROVIDERS["ALPACA"] = "alpaca";
    ACCOUNT_PROVIDERS["ESCO"] = "esco";
})(ACCOUNT_PROVIDERS || (ACCOUNT_PROVIDERS = {}));
var MERK_ORDER_SIDE;
(function (MERK_ORDER_SIDE) {
    MERK_ORDER_SIDE["BUY"] = "buy";
    MERK_ORDER_SIDE["SELL"] = "sell";
})(MERK_ORDER_SIDE || (MERK_ORDER_SIDE = {}));
var MERK_ASSET_TYPE;
(function (MERK_ASSET_TYPE) {
    MERK_ASSET_TYPE["EQUITY"] = "equity";
    MERK_ASSET_TYPE["OPTION"] = "option";
    MERK_ASSET_TYPE["FUTURE"] = "future";
    MERK_ASSET_TYPE["ETF"] = "etf";
    MERK_ASSET_TYPE["MUTUAL_FUND"] = "mutual_fund";
})(MERK_ASSET_TYPE || (MERK_ASSET_TYPE = {}));
var MERK_ORDER_TYPES;
(function (MERK_ORDER_TYPES) {
    MERK_ORDER_TYPES["MARKET"] = "market";
    MERK_ORDER_TYPES["LIMIT"] = "limit";
    MERK_ORDER_TYPES["STOP"] = "stop";
    MERK_ORDER_TYPES["STOP_LIMIT"] = "stop_limit";
    MERK_ORDER_TYPES["TRAILING_STOP"] = "trailing_stop";
})(MERK_ORDER_TYPES || (MERK_ORDER_TYPES = {}));
var MERK_ORDER_STATUS;
(function (MERK_ORDER_STATUS) {
    MERK_ORDER_STATUS["PENDING"] = "pending";
    MERK_ORDER_STATUS["FILLED"] = "filled";
    MERK_ORDER_STATUS["CANCELLED"] = "cancelled";
    MERK_ORDER_STATUS["EXPIRED"] = "expired";
    MERK_ORDER_STATUS["PARTIAL_FILLED"] = "partial_filled";
    MERK_ORDER_STATUS["REJECTED"] = "rejected";
    MERK_ORDER_STATUS["PENDING_LOCK"] = "pending_lock";
    MERK_ORDER_STATUS["LOCKED"] = "locked";
    MERK_ORDER_STATUS["FAILED_TO_LOCK"] = "failed_to_lock";
    MERK_ORDER_STATUS["FAILED_JOURNAL"] = "failed_journal";
    MERK_ORDER_STATUS["FAILED_TO_REMOVE_FUNDS"] = "failed_to_remove_funds";
    MERK_ORDER_STATUS["FUNDS_REMOVED"] = "funds_removed";
    MERK_ORDER_STATUS["AWAITING_CONFIRMATION"] = "awaiting_confirmation";
})(MERK_ORDER_STATUS || (MERK_ORDER_STATUS = {}));
var MERK_ASSET_STATUS;
(function (MERK_ASSET_STATUS) {
    MERK_ASSET_STATUS["ACTIVE"] = "active";
    MERK_ASSET_STATUS["INACTIVE"] = "inactive";
})(MERK_ASSET_STATUS || (MERK_ASSET_STATUS = {}));
var MERK_ACTIVITY_TYPE;
(function (MERK_ACTIVITY_TYPE) {
    MERK_ACTIVITY_TYPE["WITHDRAWAL"] = "withdrawal";
    MERK_ACTIVITY_TYPE["DEPOSIT"] = "deposit";
    MERK_ACTIVITY_TYPE["ORDER"] = "order";
    // From this on, this are "NON_TRADE_ACTIVITIES"
    MERK_ACTIVITY_TYPE["ACAT"] = "ACATC";
    MERK_ACTIVITY_TYPE["ACATS"] = "ACATS";
    MERK_ACTIVITY_TYPE["CIL"] = "CIL";
    MERK_ACTIVITY_TYPE["CSD"] = "CSD";
    MERK_ACTIVITY_TYPE["CSW"] = "CSW";
    MERK_ACTIVITY_TYPE["DIV"] = "DIV";
    MERK_ACTIVITY_TYPE["DIVCGL"] = "DIVCGL";
    MERK_ACTIVITY_TYPE["DIVCGS"] = "DIVCGS";
    MERK_ACTIVITY_TYPE["DIVNRA"] = "DIVNRA";
    MERK_ACTIVITY_TYPE["DIVROC"] = "DIVROC";
    MERK_ACTIVITY_TYPE["DIVTXEX"] = "DIVTXEX";
    MERK_ACTIVITY_TYPE["FEE"] = "FEE";
    MERK_ACTIVITY_TYPE["INT"] = "INT";
    MERK_ACTIVITY_TYPE["JNLS"] = "JNLS";
    MERK_ACTIVITY_TYPE["OPASN"] = "OPASN";
    MERK_ACTIVITY_TYPE["OPCA"] = "OPCA";
    MERK_ACTIVITY_TYPE["OPCSH"] = "OPCSH";
    MERK_ACTIVITY_TYPE["OPEXC"] = "OPEXC";
    MERK_ACTIVITY_TYPE["OPEXP"] = "OPEXP";
    MERK_ACTIVITY_TYPE["OPTRD"] = "OPTRD";
    MERK_ACTIVITY_TYPE["MA"] = "MA";
    MERK_ACTIVITY_TYPE["PTC"] = "PTC";
    MERK_ACTIVITY_TYPE["REORG"] = "REORG";
    MERK_ACTIVITY_TYPE["SPIN"] = "SPIN";
    MERK_ACTIVITY_TYPE["SPLIT"] = "SPLIT";
    MERK_ACTIVITY_TYPE["RECEIPT"] = "receipt";
    MERK_ACTIVITY_TYPE["COUPON"] = "coupon";
    MERK_ACTIVITY_TYPE["CHECKING_ACCOUNT_MOVEMENT"] = "checking_account_movement";
})(MERK_ACTIVITY_TYPE || (MERK_ACTIVITY_TYPE = {}));
var MERK_ACTIVITY_ORDER_STATUS;
(function (MERK_ACTIVITY_ORDER_STATUS) {
    MERK_ACTIVITY_ORDER_STATUS["NEW"] = "new";
    MERK_ACTIVITY_ORDER_STATUS["PARTIALLY_FILLED"] = "partially_filled";
    MERK_ACTIVITY_ORDER_STATUS["FILLED"] = "filled";
    MERK_ACTIVITY_ORDER_STATUS["DONE_FOR_DAY"] = "done_for_day";
    MERK_ACTIVITY_ORDER_STATUS["CANCELED"] = "canceled";
    MERK_ACTIVITY_ORDER_STATUS["EXPIRED"] = "expired";
    MERK_ACTIVITY_ORDER_STATUS["REPLACED"] = "replaced";
    MERK_ACTIVITY_ORDER_STATUS["PENDING_CANCEL"] = "pending_cancel";
    MERK_ACTIVITY_ORDER_STATUS["PENDING_REPLACE"] = "pending_replace";
    MERK_ACTIVITY_ORDER_STATUS["ACCEPTED"] = "accepted";
    MERK_ACTIVITY_ORDER_STATUS["PENDING_NEW"] = "pending_new";
    MERK_ACTIVITY_ORDER_STATUS["ACCEPTED_FOR_BIDDING"] = "accepted_for_bidding";
    MERK_ACTIVITY_ORDER_STATUS["STOPPED"] = "stopped";
    MERK_ACTIVITY_ORDER_STATUS["REJECTED"] = "rejected";
    MERK_ACTIVITY_ORDER_STATUS["SUSPENDED"] = "suspended";
    MERK_ACTIVITY_ORDER_STATUS["CALCULATED"] = "calculated";
})(MERK_ACTIVITY_ORDER_STATUS || (MERK_ACTIVITY_ORDER_STATUS = {}));
var MERK_ACTIVITY_NON_TRADE_STATUS;
(function (MERK_ACTIVITY_NON_TRADE_STATUS) {
    MERK_ACTIVITY_NON_TRADE_STATUS["EXECUTED"] = "executed";
    MERK_ACTIVITY_NON_TRADE_STATUS["CORRECT"] = "correct";
    MERK_ACTIVITY_NON_TRADE_STATUS["CANCELED"] = "canceled";
})(MERK_ACTIVITY_NON_TRADE_STATUS || (MERK_ACTIVITY_NON_TRADE_STATUS = {}));
var MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS;
(function (MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS) {
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["REFUSED"] = "refused";
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["EXECUTED"] = "executed";
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["CANCELED"] = "canceled";
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["CORRECT"] = "correct";
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["REJECTED"] = "rejected";
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["DELETED"] = "deleted";
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["QUEUED"] = "queued";
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["SENT_TO_CLEARING"] = "sent_to_clearing";
    MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS["PENDING"] = "pending";
})(MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS || (MERK_ACTIVITY_DEPOSIT_WITHDRAWAL_STATUS = {}));
var MERK_ACTIVITY_SUB_TYPE;
(function (MERK_ACTIVITY_SUB_TYPE) {
    // Dividend Subtypes
    MERK_ACTIVITY_SUB_TYPE["CDIV"] = "CDIV";
    MERK_ACTIVITY_SUB_TYPE["SDIV"] = "SDIV";
    // Fee Subtypes
    MERK_ACTIVITY_SUB_TYPE["REG"] = "REG";
    MERK_ACTIVITY_SUB_TYPE["TAF"] = "TAF";
    MERK_ACTIVITY_SUB_TYPE["LCT"] = "LCT";
    MERK_ACTIVITY_SUB_TYPE["ORF"] = "ORF";
    MERK_ACTIVITY_SUB_TYPE["OCC"] = "OCC";
    MERK_ACTIVITY_SUB_TYPE["NRC"] = "NRC";
    MERK_ACTIVITY_SUB_TYPE["NRV"] = "NRV";
    MERK_ACTIVITY_SUB_TYPE["COM"] = "COM";
    // Interest Subtypes
    MERK_ACTIVITY_SUB_TYPE["MGN"] = "MGN";
    MERK_ACTIVITY_SUB_TYPE["CDT"] = "CDT";
    MERK_ACTIVITY_SUB_TYPE["SWP"] = "SWP";
    MERK_ACTIVITY_SUB_TYPE["QII"] = "QII";
    // Merger Subtypes
    MERK_ACTIVITY_SUB_TYPE["CMA"] = "CMA";
    MERK_ACTIVITY_SUB_TYPE["SMA"] = "SMA";
    MERK_ACTIVITY_SUB_TYPE["SCMA"] = "SCMA";
    // Name Change Subtypes
    MERK_ACTIVITY_SUB_TYPE["SNC"] = "SNC";
    MERK_ACTIVITY_SUB_TYPE["CNC"] = "CNC";
    MERK_ACTIVITY_SUB_TYPE["SCNC"] = "SCNC";
    // Dividend Activity Subtypes
    MERK_ACTIVITY_SUB_TYPE["DIV_CDIV"] = "DIV.CDIV";
    MERK_ACTIVITY_SUB_TYPE["DIV_SDIV"] = "DIV.SDIV";
    // Merger Activity Subtypes
    MERK_ACTIVITY_SUB_TYPE["MA_CMA"] = "MA.CMA";
    MERK_ACTIVITY_SUB_TYPE["MA_SMA"] = "MA.SMA";
    MERK_ACTIVITY_SUB_TYPE["MA_SCMA"] = "MA.SCMA";
    // Name Change Activity Subtypes
    MERK_ACTIVITY_SUB_TYPE["NC_CNC"] = "NC.CNC";
    MERK_ACTIVITY_SUB_TYPE["NC_SNC"] = "NC.SNC";
    MERK_ACTIVITY_SUB_TYPE["NC_SCNC"] = "NC.SCNC";
    // Spinoff Activity Subtype
    MERK_ACTIVITY_SUB_TYPE["SPIN"] = "SPIN";
    // Split Activity Subtypes
    MERK_ACTIVITY_SUB_TYPE["SPLIT_FSPLIT"] = "SPLIT.FSPLIT";
    MERK_ACTIVITY_SUB_TYPE["SPLIT_RSPLIT"] = "SPLIT.RSPLIT";
    MERK_ACTIVITY_SUB_TYPE["SPLIT_USPLIT"] = "SPLIT.USPLIT";
    MERK_ACTIVITY_SUB_TYPE["WRM"] = "WRM";
    // Split Subtypes
    MERK_ACTIVITY_SUB_TYPE["FSPLIT"] = "FSPLIT";
    MERK_ACTIVITY_SUB_TYPE["RSPLIT"] = "RSPLIT";
    MERK_ACTIVITY_SUB_TYPE["USPLIT"] = "USPLIT";
    // Voluntary Activity Subtypes
    MERK_ACTIVITY_SUB_TYPE["VTND"] = "VTND";
    MERK_ACTIVITY_SUB_TYPE["VWRT"] = "VWRT";
    MERK_ACTIVITY_SUB_TYPE["VRGT"] = "VRGT";
    MERK_ACTIVITY_SUB_TYPE["VEXH"] = "VEXH";
    // Withholding Subtypes
    MERK_ACTIVITY_SUB_TYPE["SWH"] = "SWH";
    MERK_ACTIVITY_SUB_TYPE["FWH"] = "FWH";
    MERK_ACTIVITY_SUB_TYPE["SLWH"] = "SLWH";
})(MERK_ACTIVITY_SUB_TYPE || (MERK_ACTIVITY_SUB_TYPE = {}));
var MERK_DOCUMENT_TYPE;
(function (MERK_DOCUMENT_TYPE) {
    MERK_DOCUMENT_TYPE["ACCOUNT_APPLICATION"] = "account_application";
    MERK_DOCUMENT_TYPE["ACCOUNT_STATEMENT"] = "account_statement";
    MERK_DOCUMENT_TYPE["BNOTICE_1"] = "bnotice_1";
    MERK_DOCUMENT_TYPE["BNOTICE_2"] = "bnotice_2";
    MERK_DOCUMENT_TYPE["CRYPTO_ACCOUNT_STATEMENT"] = "crypto_account_statement";
    MERK_DOCUMENT_TYPE["MANDATORY_WITHHOLDING"] = "mandatory_withholding";
    MERK_DOCUMENT_TYPE["OPTIONS_APPLICATION"] = "options_application";
    MERK_DOCUMENT_TYPE["TAX_1099_B_DETAILS"] = "tax_1099_b_details";
    MERK_DOCUMENT_TYPE["TAX_1099_B_FORM"] = "tax_1099_b_form";
    MERK_DOCUMENT_TYPE["TAX_1099_DIV_DETAILS"] = "tax_1099_div_details";
    MERK_DOCUMENT_TYPE["TAX_1099_DIV_FORM"] = "tax_1099_div_form";
    MERK_DOCUMENT_TYPE["TAX_1099_INT_DETAILS"] = "tax_1099_int_details";
    MERK_DOCUMENT_TYPE["TAX_1099_INT_FORM"] = "tax_1099_int_form";
    MERK_DOCUMENT_TYPE["TAX_STATEMENT"] = "tax_statement";
    MERK_DOCUMENT_TYPE["TRADE_CONFIRMATION"] = "trade_confirmation";
})(MERK_DOCUMENT_TYPE || (MERK_DOCUMENT_TYPE = {}));
var MERK_WITHDRAW_FROM_PROVIDER_TYPE;
(function (MERK_WITHDRAW_FROM_PROVIDER_TYPE) {
    MERK_WITHDRAW_FROM_PROVIDER_TYPE["CREDIT"] = "credit";
    MERK_WITHDRAW_FROM_PROVIDER_TYPE["DEBIT"] = "debit";
})(MERK_WITHDRAW_FROM_PROVIDER_TYPE || (MERK_WITHDRAW_FROM_PROVIDER_TYPE = {}));
var MERK_WITHDRAW_FROM_PROVIDER_STATUS;
(function (MERK_WITHDRAW_FROM_PROVIDER_STATUS) {
    MERK_WITHDRAW_FROM_PROVIDER_STATUS["PENDING"] = "pending";
    MERK_WITHDRAW_FROM_PROVIDER_STATUS["FAILED"] = "failed";
    MERK_WITHDRAW_FROM_PROVIDER_STATUS["SUCCESS"] = "success";
    MERK_WITHDRAW_FROM_PROVIDER_STATUS["SWAPING"] = "swaping";
    MERK_WITHDRAW_FROM_PROVIDER_STATUS["AWAITING_CONFIRMATION"] = "awaiting_confirmation";
})(MERK_WITHDRAW_FROM_PROVIDER_STATUS || (MERK_WITHDRAW_FROM_PROVIDER_STATUS = {}));
var MERK_PROFILE_QUESTIONS_TYPES;
(function (MERK_PROFILE_QUESTIONS_TYPES) {
    MERK_PROFILE_QUESTIONS_TYPES["RADIO_BUTTON"] = "RADIO_BUTTON";
    MERK_PROFILE_QUESTIONS_TYPES["CHECKBOX"] = "CHECKBOX";
})(MERK_PROFILE_QUESTIONS_TYPES || (MERK_PROFILE_QUESTIONS_TYPES = {}));
var MERK_PROFILE_INVESTOR_TYPES;
(function (MERK_PROFILE_INVESTOR_TYPES) {
    MERK_PROFILE_INVESTOR_TYPES["MODERATE"] = "moderate";
    MERK_PROFILE_INVESTOR_TYPES["AGGRESIV"] = "aggressive";
    MERK_PROFILE_INVESTOR_TYPES["CONSERVATIVE"] = "conservative";
})(MERK_PROFILE_INVESTOR_TYPES || (MERK_PROFILE_INVESTOR_TYPES = {}));
var MERK_ACTIVITY_FILTER_BY_DATE;
(function (MERK_ACTIVITY_FILTER_BY_DATE) {
    MERK_ACTIVITY_FILTER_BY_DATE["AGREEMENT"] = "agreement";
    MERK_ACTIVITY_FILTER_BY_DATE["LIQUIDATION"] = "liquidation";
})(MERK_ACTIVITY_FILTER_BY_DATE || (MERK_ACTIVITY_FILTER_BY_DATE = {}));
var MERK_ACCOUNT_INFO_TAX_CONDITION;
(function (MERK_ACCOUNT_INFO_TAX_CONDITION) {
    MERK_ACCOUNT_INFO_TAX_CONDITION["FINAL_CONSUMER"] = "final_consumer";
    MERK_ACCOUNT_INFO_TAX_CONDITION["EXEMPT"] = "exempt";
    MERK_ACCOUNT_INFO_TAX_CONDITION["REGISTERED_RESPONSIBLE"] = "registered_responsible";
    MERK_ACCOUNT_INFO_TAX_CONDITION["SINGLE_TAX"] = "singletax";
})(MERK_ACCOUNT_INFO_TAX_CONDITION || (MERK_ACCOUNT_INFO_TAX_CONDITION = {}));
var MERK_WIZARD_TYPE;
(function (MERK_WIZARD_TYPE) {
    MERK_WIZARD_TYPE["ASSET"] = "asset";
    MERK_WIZARD_TYPE["QUESTION"] = "question";
})(MERK_WIZARD_TYPE || (MERK_WIZARD_TYPE = {}));
var FundingSource;
(function (FundingSource) {
    FundingSource["EMPLOYMENT"] = "employment_income";
    FundingSource["INVESTMENTS"] = "investments";
    FundingSource["INHERITANCE"] = "inheritance";
    FundingSource["BUSINESS"] = "business_income";
    FundingSource["SAVINGS"] = "savings";
    FundingSource["FAMILY"] = "family";
})(FundingSource || (FundingSource = {}));
var NaturalAccountStatus;
(function (NaturalAccountStatus) {
    NaturalAccountStatus["ACTIVE"] = "active";
    NaturalAccountStatus["PENDING"] = "pending";
    NaturalAccountStatus["ADMIN_REVIEW"] = "admin_review";
    NaturalAccountStatus["DELETED"] = "deleted";
    NaturalAccountStatus["REJECTED"] = "rejected";
    NaturalAccountStatus["APPROVED"] = "approved";
    NaturalAccountStatus["WAITING_FOR_EXTERNAL"] = "waiting_for_external";
    NaturalAccountStatus["FLAGGED"] = "flagged";
})(NaturalAccountStatus || (NaturalAccountStatus = {}));

var BABYLON_TIMEFRAME_CASES;
(function (BABYLON_TIMEFRAME_CASES) {
    BABYLON_TIMEFRAME_CASES["HOUR"] = "1h";
    BABYLON_TIMEFRAME_CASES["DAY"] = "1d";
    BABYLON_TIMEFRAME_CASES["WEEK"] = "1w";
    BABYLON_TIMEFRAME_CASES["MONTH"] = "1mo";
})(BABYLON_TIMEFRAME_CASES || (BABYLON_TIMEFRAME_CASES = {}));

var JARVIS_MEMBER_REPORTS_TYPE;
(function (JARVIS_MEMBER_REPORTS_TYPE) {
    JARVIS_MEMBER_REPORTS_TYPE["HOLDINGS"] = "holdings";
})(JARVIS_MEMBER_REPORTS_TYPE || (JARVIS_MEMBER_REPORTS_TYPE = {}));

var CurrencyType;
(function (CurrencyType) {
    CurrencyType["REAL_STATE"] = "real_state";
    CurrencyType["CRYPTOCURRENCY"] = "cryptocurrency";
    CurrencyType["STABLECOIN"] = "stablecoin";
    CurrencyType["FIAT"] = "fiat";
    CurrencyType["COMMODITY"] = "commodity";
})(CurrencyType || (CurrencyType = {}));

var EVENT_TRACKER_EVENT_NAMES;
(function (EVENT_TRACKER_EVENT_NAMES) {
    EVENT_TRACKER_EVENT_NAMES["API_ERROR"] = "api_error";
    EVENT_TRACKER_EVENT_NAMES["CODE_ERROR"] = "code_error";
    EVENT_TRACKER_EVENT_NAMES["USER_LOGGED_IN"] = "user_logged_in";
    EVENT_TRACKER_EVENT_NAMES["WEB_EXCEPTION"] = "web_exception";
    EVENT_TRACKER_EVENT_NAMES["UNKNOWN_ERROR"] = "unknown_error";
    EVENT_TRACKER_EVENT_NAMES["ENROLL_ERROR"] = "enroll_error";
    EVENT_TRACKER_EVENT_NAMES["LOGIN_ERROR"] = "login_error";
    EVENT_TRACKER_EVENT_NAMES["METAMAP_ERROR"] = "metamap_error";
    EVENT_TRACKER_EVENT_NAMES["ATTESTATION_ISSUE"] = "attestation_issue";
    EVENT_TRACKER_EVENT_NAMES["LEGAL_ADDRESS"] = "legal_address";
    EVENT_TRACKER_EVENT_NAMES["REGISTER"] = "register";
    EVENT_TRACKER_EVENT_NAMES["PROMOTION_CODE_SKIPPED"] = "promotion_code_skipped";
    EVENT_TRACKER_EVENT_NAMES["PROMOTION_CODE_SETTED"] = "promotion_code_setted";
    EVENT_TRACKER_EVENT_NAMES["PROMOTION_CODE_TO_SET"] = "promotion_code_to_set";
    EVENT_TRACKER_EVENT_NAMES["METAMAP_INFO"] = "metamap_info";
})(EVENT_TRACKER_EVENT_NAMES || (EVENT_TRACKER_EVENT_NAMES = {}));

class AuthenticationService {
    constructor(sConfig, fetcher) {
        const { env, version, url: configUrl } = sConfig, rest = __rest(sConfig, ["env", "version", "url"]);
        const url = configUrl || `${API_URL_CONDITION[env]}/${version}`;
        this.serviceConfig = Object.assign(Object.assign({}, sConfig), { url });
        this.defaultHeaders = {};
        this.axiosConfig = rest;
        if (fetcher) {
            this.fetcher = fetcher;
        }
        else {
            this.fetcher = axios__default["default"];
        }
    }
    async fetch(params) {
        const headers = params.headers || {};
        if (params.data instanceof formdataNode.FormData) {
            headers["Content-Type"] = "multipart/form-data";
        }
        else {
            headers["Content-Type"] = "application/json";
        }
        headers["X-app-version"] = this.serviceConfig.appVersion || "noVersion";
        headers["X-app-live-version"] =
            this.serviceConfig.appLiveVersion || "noLiveVersion";
        const response = await this.fetcher.request(Object.assign(Object.assign(Object.assign({}, this.axiosConfig), params), { data: params.data || {}, headers: Object.assign(Object.assign(Object.assign({}, this.defaultHeaders), headers), this.getAuthHeaders()) }));
        return response;
    }
}

class LogInAuthentication extends AuthenticationService {
    constructor(sConfig, fetcher) {
        super(sConfig, fetcher);
        this.publicBarong = new BarongPublic(sConfig);
        this.publicHodor = new HodorPublic(sConfig);
        this.memberBarong = new BarongMember(this);
    }
    async isAuthenticated() {
        try {
            await this.memberBarong.getUser();
            return true;
        }
        catch (error) {
            return false;
        }
    }
    async authenticate(form) {
        const isAuthenticated = await this.isAuthenticated();
        if (!isAuthenticated && form) {
            const { data: flow } = await this.publicHodor.loginBrowserBegin({
                method: LoginMethods.PASSWORD,
            });
            await this.publicHodor.loginFinish(flow.id, {
                email: form.email,
                password: form.password,
            });
        }
        else if (!isAuthenticated) {
            throw new Error("No authentication detected");
        }
    }
    async getAuthHeaders() {
        return {};
    }
}

exports.LogInAuthentication = LogInAuthentication;
//# sourceMappingURL=LogInAuthentication.js.map
